import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import TextField from '@material-ui/core/TextField';
import Config from '../../constants/appConfig';
import MaterialIcon from '../../components/MaterialIcon';
import { notification } from 'antd';
import { useParams, useLocation } from "react-router";

import jszip from 'jszip';
import togeojson from '@mapbox/togeojson';
import shpjs from 'shpjs';

import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import VisibilityIcon from '@material-ui/icons/Visibility';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

import Button from '@material-ui/core/Button';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';

import * as turf from '@turf/turf';
import tools from '../../components/util/tools';
import geo from '../../components/util/geo';

import saveAs from 'file-saver';

import HeaderSection from "./sections/Header";
import TitleSection from "./sections/Title";
import ClientSection from "./sections/Client";
import ServiceSection from "./sections/Service";
import FinanceSection from "./sections/Finance";
import SignatureSection from "./sections/Signature";
import AttachmentsSection from './sections/Attachments';

import EditProperty from '../client/property/Edit';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
  },
  tip: {
    fontSize: '1rem',
    maxWidth: 320,
    whiteSpace: 'pre-line'
  },
  tipBig: {
    fontSize: '1rem',
    maxWidth: 360,
    whiteSpace: 'pre-line'
  },
  arrow: {
    fontSize: 14
  },
  selectHelp: {
    cursor: 'help'
  }
});

class Edit extends React.Component {
  constructor(props) {
    super(props);

    const today = new Date().toLocaleDateString('sv-SE');

    this.deepClone = (o) => JSON.parse(JSON.stringify(o));

    const queryData = (this.props && this.props.query) ? this.props.query : {};

    const originFromProps =
      (this.props && this.props.jobOrigin && typeof this.props.jobOrigin === 'object')
        ? this.props.jobOrigin
        : null;

    const originFromQuery = (queryData && (queryData.origin_job_id || queryData.origin_job_guid))
      ? {
        job_id: queryData.origin_job_id ? Number(queryData.origin_job_id) : null,
        job_guid: queryData.origin_job_guid ? String(queryData.origin_job_guid) : null
      }
      : null;

    let jobOrigin = originFromProps || originFromQuery || null;
    if (!jobOrigin) {
      try {
        const saved = sessionStorage.getItem('jobOrigin');
        if (saved) jobOrigin = JSON.parse(saved);
      } catch (_) { }
    }

    this.state = {
      tabValue: 0,
      isRel: false,
      id: this.props.id || null,
      id_job: null,

      title: '',
      serviceOrder: '',
      clients: [],
      client: '',
      idClient: '',
      properties: [],
      property: '',
      idProperty: '',
      selectedPropertyIds: [],
      showCustomProperty: false,
      responsible: '',
      address: '',
      contact: '',
      obs: '',
      status: 'Aberta',

      import: { show: false, update: null, itens: [], selected: [] },
      edit: { show: false, update: null, item: null },
      list_all_prod: [],
      list_all_form: [],
      technicians: [],
      executor: '',
      executor_cfta_cpf: '',
      executorEmail: '',
      clientEmail: '',
      isSigning: false,
      imageURL: null,
      pilots: [],
      planes: [],
      jobsData: [],
      jobs: {
        id: null,
        id_job: null,
        id_job_link: null,
        guid: null,
        aplication_guid: null,
        statusService: 'Aberto',
        dateTimeTrabalho: today,
        cultura: '',
        turno: { manha: false, tarde: false },
        typeApp: { liquid: false, solid: false },
        typeService: {
          insecticide: false, herbicide: false, fungicide: false, seeding: false, fertilizing: false, maturator: false
        },

        areaRisk: { app: false, bee: false, others: false },
        areaRistOutro: '',

        plane: '',
        planeId: null,
        pilot: '',
        pilotId: null,
        pilotPhone: '',
        pilotCanac: '',
        pilotEmail: '',

        sizeArea: '',
        fluxo: '',
        larguraFaixa: '',
        application_speed: '',
        travel_speed: '',
        balloon_speed: '',
        flow_rate: '',
        hopper_load: '',
        swath_width: '',
        flight_height: '',
        balloon_width: '',
        balloon_length: '',
        espGota: '',
        qualidadeAgua: '',
        quantidadeLitrosKg: '',

        equipment: {
          type: '',
          name: '',
          details: { core: '', disco: '', angulo: '', ponta: '', anguloPa: '', malha: '', vru: '', orificio: '' }
        },

        list_prod: [],
        list_form: [],
        list_areas: [],
        list_points: [],

        finance: {
          valuePerHa: '',
          paymentMethod: '',
          dueDate: '',
          confirmPayment: false,
          paymentDate: '',
          discountEnabled: false,
          discountValue: '',
          discountPercent: ''
        },
        guidDocument: '',
        openModal: false,
        documentData: null,
        documentParts: [],
        allSigned: false,
        docDeleteConfirmOpen: false
      },

      modalOpen: false,
      editIndex: null,

      financeEditOpen: false,
      financeEditIndex: null,

      expandedRows: [],
      serviceOrderData: null,

      fileSigned: '',
      isGeneratingReport: false,
      cultureData: [],
      attachments: [],
      attachmentsRemoveIds: [],

      jobAreas: {},
      jobAreasLoading: {},
      areaTabByJob: {},

      productFilter: '',
      productPage: 1,
      newProductModalOpen: false,
      newProductName: '',
      newProductSaving: false,

      editForm: this.props.id ? false : true,

      jobOrigin: jobOrigin || null,
      osOrigin: jobOrigin || null,

      editShare: false,
      dataShare: [],
      shareModalOpen: false,
      selectedShareCompanyId: null,
      loadingShareList: false,
      sendingShare: false,
      sendingReturn: false,
      companyOriginID: null,
      companyID: null,
      companyOriginName: null,
      companySharedName: null,
      list_exe_return: [],
      list_plan_return: [],
      openReturnConfirm: false,
      share_status: null,
      list_relMapa: [],
      list_plan: [],
      list_exe: [],
      menuAnchorEl: null,

      registeredAreas: [],
      registeredAreaClients: [],
      registeredAreaProperties: [],
      registeredAreaFolders: [],
      registeredAreasByClient: [],
      isSavingServiceOrder: false,
      isPlanningProcessing: false,

      showPropertyForm: false,
      propertyModalKey: 0,

      runways: [],
    };

    this.signaturePadRef = React.createRef();
    this.type_import = '';
    this.attachmentInputRef = React.createRef();
    this.serviceOrderEventsAbort = null;
    this.serviceOrderEventsData = '';
    this.planningProcessingNotificationKey = 'service_order_planning_processing';
    this.prefilledClientToApply = null;
  }

  componentDidMount() {
    this.getProd();
    this.getForm();
    this.readTechnician();
    this.readCustomers();
    this.readPilots();
    this.readPlanes();
    this.loadCultures();
    this.updateShareCompanyList();
    this.loadAreas(0);
    this.readRunways();
    this.startServiceOrderEvents();

    try {
      if (this.state.jobOrigin) {
        sessionStorage.setItem('jobOrigin', JSON.stringify(this.state.jobOrigin));
      }
    } catch (_) { }

    if (this.state.id) {
      this.readServiceOrderById();
    } else {
      this.readServiceOrder();
      this.openPrefilledAreasService();
    }
  }

  componentWillUnmount() {
    // fix Warning: Can't perform a React state update on an unmounted component
    this.setState = (state, callback) => {
      return;
    };

    this.stopServiceOrderEvents();
    this.closePlanningProcessingNotification();
  };

  stopServiceOrderEvents = () => {
    try {
      if (this.serviceOrderEventsAbort) {
        this.serviceOrderEventsAbort.abort();
        this.serviceOrderEventsAbort = null;
      }
    } catch (_) { }

    this.serviceOrderEventsData = '';
  };

  startServiceOrderEvents = () => {
    if (!window.fetch || !window.AbortController) {
      return;
    }

    this.stopServiceOrderEvents();

    const abortController = new AbortController();
    this.serviceOrderEventsAbort = abortController;

    const apiUrl = Config.server + '/service_order/events';
    const options = {
      method: 'GET',
      headers: { 'Authorization': localStorage.getItem('access-token-jwt') },
      signal: abortController.signal
    };

    fetch(apiUrl, options)
      .then((response) => {
        if (response.status !== 200) return;

        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');

        const read = () => {
          return reader.read().then(({ done, value }) => {
            if (done) return;

            this.serviceOrderEventsData += decoder.decode(value, { stream: true });

            const events = this.serviceOrderEventsData.split('\n\n');
            this.serviceOrderEventsData = events.pop() || '';

            for (let i = 0; i < events.length; i++) {
              this.handleServiceOrderEvent(events[i]);
            }

            return read();
          });
        };

        return read();
      })
      .catch(() => { });
  };

  getPlanningProcessingKey = (id) => {
    const serviceOrderId = id || this.state.id;
    return serviceOrderId ? 'service_order_planning_processing_' + serviceOrderId : '';
  };

  savePlanningProcessingStorage = (id) => {
    const key = this.getPlanningProcessingKey(id);
    if (key) sessionStorage.setItem(key, '1');
  };

  clearPlanningProcessingStorage = (id) => {
    const key = this.getPlanningProcessingKey(id);
    if (key) sessionStorage.removeItem(key);
  };

  hasPlanningProcessingStorage = (id) => {
    const key = this.getPlanningProcessingKey(id);
    return key ? sessionStorage.getItem(key) === '1' : false;
  };

  openPlanningProcessingNotification = () => {
    notification.open({
      key: this.planningProcessingNotificationKey,
      message: this.props.res.AGUARDE,
      description: this.props.res.PLANEJAMENTO_PROCESSANDO,
      duration: 0,
      icon: <HourglassEmptyIcon className="text-warning" />
    });
  };

  closePlanningProcessingNotification = () => {
    notification.close(this.planningProcessingNotificationKey);
  };

  setPlanningProcessing = (isProcessing, serviceOrderId) => {
    if (isProcessing) {
      this.savePlanningProcessingStorage(serviceOrderId);
    } else {
      this.clearPlanningProcessingStorage(serviceOrderId);
    }

    this.setState({ isPlanningProcessing: !!isProcessing });

    if (isProcessing) {
      this.openPlanningProcessingNotification();
    } else {
      this.closePlanningProcessingNotification();
    }
  };

  isPlanningButtonDisabled = () => {
    return !!this.state.isPlanningProcessing;
  };

  handleServiceOrderEvent = (rawEvent) => {
    if (!rawEvent) return;

    const lines = String(rawEvent).split('\n');
    let eventName = '';
    let dataRaw = '';

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];

      if (!line || line.charAt(0) === ':') continue;

      if (line.indexOf('event:') === 0) {
        eventName = line.substring(6).trim();
      } else if (line.indexOf('data:') === 0) {
        dataRaw += line.substring(5).trim();
      }
    }

    if (eventName !== 'service_order_planning_finished') return;

    let data = {};
    try {
      data = JSON.parse(dataRaw || '{}');
    } catch (_) {
      data = {};
    }

    const isCurrentServiceOrder = this.state.id && Number(this.state.id) === Number(data.id_service_order);
    if (this.state.id && !isCurrentServiceOrder) return;

    this.setPlanningProcessing(false, data.id_service_order);

    notification.open({
      message: this.props.res.SUCESSO,
      description: this.props.res.PLANEJAMENTO_FINALIZADO,
      icon: <MaterialIcon icon="check_circle" className="text-success" />
    });

    if (isCurrentServiceOrder) {
      this.readServiceOrderById(this.state.id, true);
    }
  };

  handleChange = (name) => (event) => {
    if (!event.target) {
      return;
    }
    const { value } = event.target;

    this.setState({ [name]: value, isRel: false });
  };

  getProd = () => {
    const apiUrl = Config.server + '/product';
    const options = { method: 'GET', headers: { 'Authorization': localStorage.getItem('access-token-jwt') } };

    fetch(apiUrl, options)
      .then((res) => { if (res.status !== 200) throw res; return res.json(); })
      .then((result) => {
        if (Array.isArray(result)) {
          const normalized = result.map((item, key) => {
            const id = Number(item.id);
            return {
              ...item,
              id,
              index: key,
              source: 'master',
              is_custom: false,
              uid: `master:${id}`
            };
          });
          this.setState({ list_all_prod: normalized }, () => this.getProdCustom());
        }
      })
      .catch((error) => {
        if (error.status === 401) this.props.link('/login');
        else {
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
      });
  };

  getForm = () => {
    const apiUrl = Config.server + '/form';
    const options = { method: 'GET', headers: { 'Authorization': localStorage.getItem('access-token-jwt') } };

    fetch(apiUrl, options)
      .then((res) => { if (res.status !== 200) throw res; return res.json(); })
      .then((result) => {
        if (Array.isArray(result)) {
          this.setState({ list_all_form: result.map((item, key) => ({ ...item, index: key, name: item.cod + ' - ' + item.description })) });
        }
      })
      .catch((error) => {
        if (error.status === 401) this.props.link('/login');
        else {
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
      });
  }

  readTechnician = () => {
    const apiUrl = `${Config.server}/technician`;
    const options = { method: 'GET', headers: { 'Authorization': localStorage.getItem('access-token-jwt') } };

    fetch(apiUrl, options)
      .then((res) => { if (res.status !== 200) throw res; return res.json(); })
      .then((result) => {
        if (result.length > 0) {
          const technician = result[0];
          this.setState({
            technicians: result,
            id_technician: technician.id,
            executor: technician.name,
            executor_cfta_cpf: technician.cfta,
            executorEmail: technician.email,
          });
        }
      })
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        }
      });
  };

  handleCheck = (type, name) => (event) => {
    let state = this.state[type];
    state[name] = !this.state[type][name];
    this.setState({ [type]: state, isRel: false });
  };

  addList = (listField, listAllField) => (event) => {
    const catalog = Array.isArray(this.state[listAllField]) ? this.state[listAllField] : [];
    const selected = Array.isArray(this.getTrabalho()[listField]) ? this.getTrabalho()[listField] : [];

    const temp_import = {
      ...this.state.import,
      show: true,
      itens: [...catalog],
      selected: [...selected],
    };

    temp_import.update = (itens) => {
      const temp_itens = Array.isArray(itens) ? [...itens] : [];

      this.setState(
        prev => ({ import: { ...prev.import, show: false }, isRel: false }),
        () => this.setTrabalhoValor(listField, temp_itens)
      );
    };
    this.setState({ import: temp_import, isRel: false });
  };

  loadFile = file => {
    if (file.target.files.length > 0) this.showPro(true);
    for (let index = 0; index < file.target.files.length; index++) {
      const filePath = file.target.files[index];
      setTimeout(() => {
        let ext = fileName => fileName.split(".").pop();
        if (ext(filePath.name.toLowerCase()) === 'kml') {
          this.fileReader = new FileReader();
          this.fileReader.onloadend = ((e) => {
            const content = this.fileReader.result;
            let parser = new DOMParser();
            let xmlDoc = parser.parseFromString(content, "text/xml");
            let track = new togeojson['kml'](xmlDoc);

            this.writeFileMap(track);
          });
          this.fileReader.readAsText(filePath);
        } else if (ext(filePath.name.toLowerCase()) === 'kmz') {
          let getDom = xml => (new DOMParser()).parseFromString(xml, "text/xml")
          let getKmlDom = (kmzFile) => {
            let zip = new jszip()
            return zip.loadAsync(kmzFile)
              .then(zip => {
                let kmlDom = null
                zip.forEach((relPath, file) => {
                  if (ext(relPath) === 'kml') {
                    kmlDom = file.async("string").then(getDom)
                  }
                })
                return kmlDom || Promise.reject("No kml file found")
              });
          }
          let geoJson = getKmlDom(filePath).then(kmlDom => {
            let geoJsonObject = new togeojson['kml'](kmlDom);
            return geoJsonObject
          })
          geoJson.then(gj => this.writeFileMap(gj))
        } else if (ext(filePath.name.toLowerCase()) === 'zip') {
          this.fileReader = new FileReader();
          this.fileReader.onloadend = ((e) => {
            shpjs(this.fileReader.result)
              .then((geojson) => {
                if (geojson.length > 0) {
                  geojson.forEach(element => {
                    this.writeFileMap(element);
                  });
                } else {
                  this.writeFileMap(geojson);
                }
              })
              .catch(e => {
                this.showPro(false);
                notification.open({
                  message: this.props.res.ERRO,
                  description: this.props.res.MSG_ERRO_ARQUIVO_NAO_SUPORTADO,
                  icon: <MaterialIcon icon="error" className="text-danger" />
                });
              });
          });
          this.fileReader.readAsArrayBuffer(filePath);
        } else if (ext(filePath.name.toLowerCase()) === 'shp') {
          this.fileReader = new FileReader();
          this.fileReader.onloadend = ((e) => {
            const features = [];
            let polyLength = 0;
            shpjs.parseShp(this.fileReader.result).forEach(element => {
              const geometry = { type: element.type, coordinates: element.coordinates };
              features.push({ properties: { guid: undefined, name: undefined, type: element.type }, geometry: geometry });
              if (element.type === "Polygon") {
                polyLength++;
              } else if (element.type === "MultiPolygon") {
                polyLength += element.coordinates.length;
              }
            });
            this.writeFileMap({ features: features, polyLength: polyLength });
          });
          this.fileReader.readAsArrayBuffer(filePath);
        } else {
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.MSG_ERRO_ARQUIVO_NAO_SUPORTADO,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
          this.showPro(false);
        }
      }, 50);
    };
  };

  writeFileMap = (track) => {
    const items = [];
    let seq = 1;

    for (let i = 0; i < track.features.length; i++) {
      const feature = track.features[i];
      const isPoint = feature.geometry.type === 'Point';
      const isPolygonLike = ['Polygon', 'GeometryCollection', 'MultiPolygon', 'LineString'].includes(feature.geometry.type);

      if ((this.type_import === 'Points' && isPoint) ||
        (this.type_import !== 'Points' && isPolygonLike)) {
        const name = feature.properties?.name || feature.properties?.recibo || `${this.props.AREA} ${seq++}`;
        items.push({ name, feature, index: i });
      }
    }

    const temp_import = {
      ...this.state.import,
      show: true,
      itens: items,
      selected: [],
    };

    temp_import.update = (itens) => {
      const withGuids = (Array.isArray(itens) ? itens : []).map(x => ({ ...x, guid: tools.newGuid() }));
      const mapped = this.fileMap(withGuids);
      const targetList = (this.type_import === 'Points') ? 'list_points' : 'list_areas';

      this.setState(
        prev => ({ import: { ...prev.import, show: false } }),
        () => {
          const atual = Array.isArray(this.getTrabalho()[targetList]) ? this.getTrabalho()[targetList] : [];
          this.setTrabalhoValor(targetList, mapped.concat(atual));
          this.showPro(false);
        }
      );
    };

    this.setState({ import: temp_import });
  };

  geoInvertArray = (poly) => {
    let array = [];
    for (let i = 0; i < poly.length; i++) {
      array.push([poly[i][1], poly[i][0]]);
    }
    return array;
  };

  nextIndex = (listP) => {
    let lastI = 1;
    let retorno = this.text_polygon + lastI;
    for (let i = 0; i < listP.length; i++) {
      if (listP[i].name === retorno) {
        i = -1;
        lastI++;
      }
      retorno = this.text_polygon + lastI;
    }
    return retorno;
  };

  fileMap = (tFeatures) => {
    let list_area = [];
    for (let i = 0; i < tFeatures.length; i++) {
      //const element = turfS(track.features[i], {tolerance: 0.00005, highQuality: true});
      let features = tFeatures[i].feature;
      if (features.geometry.type === 'Polygon') {
        //polys = this.loadPolyFile(features.properties, features.geometry.coordinates[0], polys);
        let c = turf.center(features);
        list_area.push({
          name: tFeatures[i].name,
          lng: c ? geo.toDMS(c.geometry.coordinates[1], 'latitude', 4) : '',
          lat: c ? geo.toDMS(c.geometry.coordinates[0], 'longitude', 4) : '',
          points_place: JSON.stringify(this.geoInvertArray(features.geometry.coordinates[0])),
          guid: tools.newGuid(),
          type: 'area'
        });
      } else if (features.geometry.type === 'MultiPolygon') {
        for (let j = 0; j < features.geometry.coordinates.length; j++) {
          features.properties.type = 'Polygon';
          //polys = this.loadPolyFile(features.properties, features.geometry.coordinates[j][0], polys);
          let c = turf.center(turf.polygon(features.geometry.coordinates[j][0]));
          list_area.push({
            name: tFeatures[i].name,
            lng: c ? geo.toDMS(c.geometry.coordinates[1], 'latitude', 4) : '',
            lat: c ? geo.toDMS(c.geometry.coordinates[0], 'longitude', 4) : '',
            points_place: JSON.stringify(this.geoInvertArray(features.geometry.coordinates[j][0])),
            guid: tools.newGuid(),
            type: 'area'
          });
        }
      } else if (features.geometry.type === 'GeometryCollection') {
        let geometries = features.geometry.geometries;
        for (let j = 0; j < geometries.length; j++) {
          let element = geometries[j];
          if (element.type === 'Polygon') {
            //polys = this.loadPolyFile(features.properties, element.coordinates[0], polys);
            let c = turf.center(turf.polygon(element.coordinates[0]));
            list_area.push({
              name: tFeatures[i].name,
              lng: c ? geo.toDMS(c.geometry.coordinates[1], 'latitude', 4) : '',
              lat: c ? geo.toDMS(c.geometry.coordinates[0], 'longitude', 4) : '',
              points_place: JSON.stringify(this.geoInvertArray(element.coordinates[0])),
              guid: tools.newGuid(),
              type: 'area'
            });
          } else if (element.type === 'LineString') {
            //polys = this.loadPolyFile(features.properties, element.coordinates, polys);
            let c = turf.center(turf.polygon(element.coordinates));
            list_area.push({
              name: tFeatures[i].name,
              lng: c ? geo.toDMS(c.geometry.coordinates[1], 'latitude', 4) : '',
              lat: c ? geo.toDMS(c.geometry.coordinates[0], 'longitude', 4) : '',
              points_place: JSON.stringify(this.geoInvertArray(element.coordinates)),
              guid: tools.newGuid(),
              type: 'area'
            });
          }
        }
      } else if (features.geometry.type === 'LineString') {
        const arr1 = features.geometry.coordinates[0];
        const arr2 = features.geometry.coordinates[features.geometry.coordinates.length - 1];
        if (arr1[0] === arr2[0] && arr1[1] === arr2[1]) {
          //polys = this.loadPolyFile(features.properties, features.geometry.coordinates, polys);
          let c = turf.center(turf.polygon([features.geometry.coordinates]));
          list_area.push({
            name: tFeatures[i].name,
            lng: c ? geo.toDMS(c.geometry.coordinates[1], 'latitude', 4) : '',
            lat: c ? geo.toDMS(c.geometry.coordinates[0], 'longitude', 4) : '',
            points_place: JSON.stringify(this.geoInvertArray(features.geometry.coordinates)),
            guid: tools.newGuid(),
            type: 'area'
          });
        }
      } else if (features.geometry.type === 'Point') {
        list_area.push({
          name: tFeatures[i].name,
          lng: geo.toDMS(features.geometry.coordinates[1], 'latitude', 4),
          lat: geo.toDMS(features.geometry.coordinates[0], 'longitude', 4),
          points_place: JSON.stringify(this.geoInvertArray([features.geometry.coordinates])),
          guid: tools.newGuid(),
          type: 'point'
        });
      }
    }
    return list_area;
  };

  showEditArea = (fromKey) => (guidOrItem) => {
    const prev = this.state.edit || {};
    const job = (this.getTrabalho && typeof this.getTrabalho === 'function') ? this.getTrabalho() : null;
    const listFromJob = Array.isArray(job?.[fromKey]) ? job[fromKey] : null;
    const listFromState = Array.isArray(this.state?.[fromKey]) ? this.state[fromKey] : [];
    const list = listFromJob || listFromState;

    let item = (guidOrItem && typeof guidOrItem === 'object') ? guidOrItem : null;
    if (!item && guidOrItem != null) {
      const key = String(guidOrItem);
      item = list.find((x) => x && (String(x.guid) === key || String(x.id) === key)) || null;
    }

    const edit = { ...prev, show: true, update: fromKey, item };
    this.setState({ edit });
  };

  onCloseEditArea = () => {
    const prev = this.state.edit || {};
    this.setState({ edit: { ...prev, show: false, item: null } });
  };

  onCloseFilterArea = () => {
    const prev = this.state.import || {};
    this.setState({ import: { ...prev, show: false } });
    this.showPro(false);
  };

  showPro = (visible) => {
    const node = document.getElementById('divPro');
    if (!node) return;
    node.classList.remove('sr-only');
    if (!visible) node.classList.toggle('sr-only');
  };

  updateArea = (fromKey) => (rawItem, opType) => {
    const job = (this.getTrabalho && typeof this.getTrabalho === 'function') ? this.getTrabalho() : null;
    const currentJobList = Array.isArray(job && job[fromKey]) ? [...job[fromKey]] : null;
    const currentStateList = Array.isArray(this.state && this.state[fromKey]) ? [...this.state[fromKey]] : [];
    const list = currentJobList || currentStateList;

    const kind = fromKey === 'list_points' ? 'point' : 'area';
    const item = { ...rawItem, type: kind };

    if (!item.guid || String(item.guid).trim() === '') {
      const makeGuid = () =>
        (typeof tools !== 'undefined' && tools && typeof tools.newGuid === 'function')
          ? tools.newGuid()
          : `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`;
      item.guid = makeGuid();
    }

    if (opType === 'update') {
      const index = list.findIndex((obj) => obj && String(obj.guid) === String(item.guid));
      if (index >= 0) list[index] = item;
      else list.push(item);
    } else {
      list.push(item);
    }

    this.onCloseEditArea();

    if (currentJobList && typeof this.setTrabalhoValor === 'function') {
      this.setTrabalhoValor(fromKey, list);
      this.setState({ isRel: false }, () => {
        if (fromKey === 'list_areas' && typeof this.computeAndSetSizeArea === 'function') {
          this.computeAndSetSizeArea(list);
        } else if (typeof this.selectedProductsTotals === 'function') {
          this.selectedProductsTotals();
        }
      });
    } else {
      this.setState({ [fromKey]: list, isRel: false }, () => {
        if (fromKey === 'list_areas' && typeof this.computeAndSetSizeArea === 'function') {
          this.computeAndSetSizeArea(list);
        } else if (typeof this.selectedProductsTotals === 'function') {
          this.selectedProductsTotals();
        }
      });
    }
  };

  updateAreas = (listKey, items, removedCsv) => {
    const job = (this.getTrabalho && typeof this.getTrabalho === 'function') ? this.getTrabalho() : null;
    const nextItems = Array.isArray(items) ? [...items] : [];
    const removedKey = `${listKey}_r`;

    if (job && Array.isArray(job[listKey]) && typeof this.setTrabalhoValor === 'function') {
      this.setTrabalhoValor(listKey, nextItems);
      const prevRemoved = this.state[removedKey] || '';
      const nextRemoved = removedCsv ? (prevRemoved ? `${removedCsv},${prevRemoved}` : removedCsv) : prevRemoved;
      const update = { isRel: false };
      if (nextRemoved !== prevRemoved) update[removedKey] = nextRemoved;
      this.setState(update);
    } else {
      const prevRemoved = this.state[removedKey] || '';
      const nextRemoved = removedCsv ? (prevRemoved ? `${removedCsv},${prevRemoved}` : removedCsv) : prevRemoved;
      const update = { [listKey]: nextItems, isRel: false };
      if (nextRemoved !== prevRemoved) update[removedKey] = nextRemoved;
      this.setState(update);
    }
  };

  handleTechnicianChange = (event) => {
    const selectedTechnician = this.state.technicians.find(technician => technician.name === event.target.value);
    this.setState({
      executor: selectedTechnician.name,
      executor_cfta_cpf: selectedTechnician.cfta,
      executorEmail: selectedTechnician.email,
    });
  };

  readPilots = () => {
    const apiUrl = `${Config.server}/pilot`;
    const apiUrlPerm = `${Config.server}/pilot/perm`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    Promise.all([
      fetch(apiUrl, options),
      fetch(apiUrlPerm, options)
    ])
      .then((responses) => {
        for (let i = 0; i < responses.length; i++) {
          if (responses[i].status !== 200) throw responses[i];
        }
        return Promise.all(responses.map((res) => res.json()));
      })
      .then((result) => {
        const pilots = Array.isArray(result[0]) ? result[0] : [];
        const permPilots = Array.isArray(result[1]) ? result[1] : [];

        const merged = [];
        const seen = {};

        for (let i = 0; i < pilots.length; i++) {
          const pilot = pilots[i];
          if (pilot && pilot.id != null && !seen[pilot.id]) {
            seen[pilot.id] = true;
            merged.push(pilot);
          }
        }

        for (let i = 0; i < permPilots.length; i++) {
          const pilot = permPilots[i];
          if (!pilot || pilot.id == null) continue;

          const pilotName = pilot.name ? String(pilot.name) : '';
          const companyName = pilot.company_name ? String(pilot.company_name) : '';

          const mergedPilot = Object.assign({}, pilot, {
            name: companyName ? pilotName + ' - ' + companyName : pilotName
          });

          if (!seen[pilot.id]) {
            seen[pilot.id] = true;
            merged.push(mergedPilot);
          }
        }

        if (merged.length > 0) {
          this.setState({
            pilots: merged,
          });
        }
      })
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        } else {
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
      });
  };

  readPlanes = () => {
    const apiUrl = `${Config.server}/plane`;
    const apiUrlPerm = `${Config.server}/plane/perm`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    Promise.all([
      fetch(apiUrl, options),
      fetch(apiUrlPerm, options)
    ])
      .then((responses) => {
        for (let i = 0; i < responses.length; i++) {
          if (responses[i].status !== 200) throw responses[i];
        }
        return Promise.all(responses.map((res) => res.json()));
      })
      .then((result) => {
        const planes = Array.isArray(result[0]) ? result[0] : [];
        const permPlanes = Array.isArray(result[1]) ? result[1] : [];

        const merged = [];
        const seen = {};
        for (let i = 0; i < planes.length; i++) {
          const planeItem = planes[i];
          if (planeItem && planeItem.id != null && !seen[planeItem.id]) {
            seen[planeItem.id] = true;
            merged.push(planeItem);
          }
        }

        for (let i = 0; i < permPlanes.length; i++) {
          const plane = permPlanes[i];
          if (!plane || plane.id == null) continue;

          const planeName = plane.name ? String(plane.name) : '';
          const companyName = plane.company_name ? String(plane.company_name) : '';

          const mergedPlane = Object.assign({}, plane, {
            name: companyName ? planeName + ' - ' + companyName : planeName
          });

          if (!seen[plane.id]) {
            seen[plane.id] = true;
            merged.push(mergedPlane);
          }
        }

        if (merged.length > 0) {
          this.setState({
            planes: merged,
          });
        }
      })
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        } else {
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
      });
  };

  readCustomers = () => {
    const apiUrl = `${Config.server}/customer`;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then((result) => {
        const clients = Array.isArray(result) ? result : [];
        this.setState({
          clients: clients,
          registeredAreaClients: clients
        }, () => {
          const prefilledClient = this.prefilledClientToApply || this.getPrefilledClientFromNavigation();
          const prefilledClientId = prefilledClient ? (prefilledClient.id ? prefilledClient.id : prefilledClient.id_client) : '';
          if (!this.state.id && prefilledClient && (!this.state.idClient || Number(this.state.idClient) === Number(prefilledClientId))) {
            this.applyPrefilledClient(prefilledClient);
          }
        });
      })
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        }
      });
  };


  formatAddressFromItem = (item) => {
    if (!item) return '';

    const logradouro = item.logradouro ? String(item.logradouro).trim() : '';
    const numero = item.numero ? String(item.numero).trim() : '';

    let address = logradouro;
    if (numero) address += (address ? ', ' : '') + numero;

    if (!address && item.address) address = String(item.address).trim();

    return address;
  };

  getClientAddress = (clientId) => {
    const clients = Array.isArray(this.state.clients) ? this.state.clients : [];
    const selectedClient = clients.find(client => client && Number(client.id) === Number(clientId));
    return this.formatAddressFromItem(selectedClient);
  };

  getSelectedPropertyState = (selectedProperties) => {
    const properties = Array.isArray(selectedProperties) ? selectedProperties : [];
    const propertyNames = [];
    const propertyIds = [];
    const propertyAddresses = [];
    const propertyObservations = [];

    for (let i = 0; i < properties.length; i++) {
      const property = properties[i];
      if (!property) continue;

      if (property.id !== undefined && property.id !== null && property.id !== '') {
        propertyIds.push(property.id);
      }

      if (property.name) {
        propertyNames.push(String(property.name).trim());
      }

      const address = this.formatAddressFromItem(property);
      if (address) {
        propertyAddresses.push(address);
      }

      if (property.obs) {
        propertyObservations.push(String(property.obs).trim());
      }
    }

    return {
      property: propertyNames.join(', '),
      idProperty: propertyIds.length ? propertyIds[0] : '',
      selectedPropertyIds: propertyIds,
      showCustomProperty: false,
      address: propertyAddresses.length ? propertyAddresses.join(' / ') : this.getClientAddress(this.state.idClient),
      obs: propertyObservations.join(' / ')
    };
  };

  buildServiceOrderPropertiesPayload = () => {
    if (this.state.showCustomProperty) {
      return [];
    }

    const ids = [];
    const selectedIds = Array.isArray(this.state.selectedPropertyIds) ? this.state.selectedPropertyIds : [];
    const serviceOrderProperties = this.state.serviceOrderData && Array.isArray(this.state.serviceOrderData.properties)
      ? this.state.serviceOrderData.properties
      : [];

    for (let i = 0; i < selectedIds.length; i++) {
      const id = Number(selectedIds[i]);
      if (Number.isInteger(id) && id > 0 && ids.indexOf(id) < 0) {
        ids.push(id);
      }
    }

    if (!ids.length) {
      for (let i = 0; i < serviceOrderProperties.length; i++) {
        const item = serviceOrderProperties[i] || {};
        const id = Number(item.id_property || item.idProperty || item.property_id || item.propertyId || item.id);
        if (Number.isInteger(id) && id > 0 && ids.indexOf(id) < 0) {
          ids.push(id);
        }
      }
    }

    const properties = Array.isArray(this.state.properties) ? this.state.properties : [];
    const propertyNames = String(this.state.property || '')
      .split(',')
      .map((item) => String(item || '').trim())
      .filter(Boolean);
    const propertyAddresses = String(this.state.address || '')
      .split('/')
      .map((item) => String(item || '').trim())
      .filter(Boolean);

    const payload = [];

    for (let i = 0; i < ids.length; i++) {
      const idProperty = ids[i];

      const propertyItem = properties.find((item) => item && Number(item.id) === Number(idProperty)) ||
        serviceOrderProperties.find((item) => item && Number(item.id_property || item.id) === Number(idProperty)) ||
        null;

      let propertyName = '';
      let propertyAddress = '';

      if (propertyItem) {
        propertyName = propertyItem.name || propertyItem.property || propertyItem.property_name || '';
        propertyAddress = this.formatAddressFromItem(propertyItem) || propertyItem.address || propertyItem.property_address || '';
      }

      if (!propertyName && propertyNames[i]) {
        propertyName = propertyNames[i];
      }

      if (!propertyAddress && propertyAddresses[i]) {
        propertyAddress = propertyAddresses[i];
      }

      if (!propertyAddress && ids.length === 1 && this.state.address) {
        propertyAddress = this.state.address;
      }

      payload.push({
        id_property: idProperty,
        name: propertyName || '',
        address: propertyAddress || ''
      });
    }

    return payload;
  };

  clearSelectedProperties = () => {
    this.setState({
      property: '',
      idProperty: '',
      selectedPropertyIds: [],
      obs: '',
      address: this.getClientAddress(this.state.idClient)
    });
  };

  applyPrefilledClient = (clientData) => {
    if (!clientData) return;

    if (!this.state.clients || this.state.clients.length === 0) {
      this.prefilledClientToApply = clientData;
      return;
    }

    const idClient = clientData.id || clientData.id_client || '';
    const clientName = clientData.name || clientData.client || '';
    const idProperty = clientData.id_property || clientData.idProperty || '';

    if (!idClient && !clientName) return;

    const selectedClient = this.state.clients.find(client =>
      (idClient && Number(client.id) === Number(idClient)) ||
      (clientName && client.name === clientName)
    );

    const applyProperty = (properties) => {
      const prop = idProperty
        ? properties.find(p => Number(p.id) === Number(idProperty))
        : null;

      if (prop) {
        this.setState(this.getSelectedPropertyState([prop]));
      }
    };

    try {
      sessionStorage.removeItem('serviceOrderPrefillClient');
    } catch (_) { }
    this.prefilledClientToApply = null;

    if (!selectedClient) {
      this.setState({
        client: clientName,
        idClient: idClient,
        properties: [],
        property: '',
        idProperty: '',
        selectedPropertyIds: [],
        showCustomProperty: false,
        responsible: '',
        contact: '',
        address: '',
        obs: ''
      }, () => {
        if (idClient) this.readProperties(idClient, applyProperty);
      });
      return;
    }

    const fullAddress = this.formatAddressFromItem(selectedClient);

    this.setState({
      client: selectedClient.name,
      idClient: selectedClient.id,
      contact: selectedClient.fone || selectedClient.phone || '',
      clientEmail: selectedClient.email || '',
      responsible: selectedClient.responsible || selectedClient.responsavel || '',
      address: fullAddress,
      properties: [],
      property: '',
      idProperty: '',
      selectedPropertyIds: [],
      showCustomProperty: false,
      obs: ''
    }, () => {
      this.readProperties(selectedClient.id, applyProperty);
    });
  };

  handleClientChange = (event) => {
    const clientName = event && event.target ? event.target.value : '';

    if (!clientName) {
      this.setState({
        client: '',
        idClient: '',
        properties: [],
        property: '',
        idProperty: '',
        selectedPropertyIds: [],
        showCustomProperty: false,
        responsible: '',
        contact: '',
        address: '',
        obs: ''
      });
      return;
    }

    const selectedCustomers = this.state.clients.find(client => client.name === clientName);

    if (!selectedCustomers) {
      this.setState({
        client: '',
        idClient: '',
        properties: [],
        property: '',
        idProperty: '',
        selectedPropertyIds: [],
        showCustomProperty: false,
        responsible: '',
        contact: '',
        address: '',
        obs: ''
      });
      return;
    }

    const fullAddress = this.formatAddressFromItem(selectedCustomers);

    this.setState({
      client: selectedCustomers.name,
      contact: selectedCustomers.fone || '',
      clientEmail: selectedCustomers.email || '',
      address: fullAddress,
      idClient: selectedCustomers.id,
      responsible: selectedCustomers.responsible || '',
      properties: [],
      property: '',
      idProperty: '',
      selectedPropertyIds: [],
      showCustomProperty: false,
      obs: ''
    }, () => {
      this.readProperties(selectedCustomers.id);
    });
  };

  readProperties = (idClient, callback) => {
    if (!idClient) {
      this.setState({ properties: [] }, () => {
        if (typeof callback === 'function') callback([]);
      });
      return;
    }

    const apiUrl = Config.server + '/properties/' + idClient;

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then((result) => {
        const propertyList = Array.isArray(result) ? result : [];
        this.setState({
          properties: propertyList
        }, () => {
          if (typeof callback === 'function') callback(propertyList);
        });
      })
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        }
      });
  };

  handlePropertyChange = (event) => {
    const value = event && event.target && Array.isArray(event.target.value) ? event.target.value : [];

    if (!value.length) {
      this.clearSelectedProperties();
      return;
    }

    const properties = Array.isArray(this.state.properties) ? this.state.properties : [];
    const selectedProperties = properties.filter(property => value.some(id => Number(id) === Number(property.id)));

    if (selectedProperties.length > 0) {
      this.setState(this.getSelectedPropertyState(selectedProperties));
    }
  };

  handlePropertyInputChange = (event) => {
    const value = event && event.target ? event.target.value : '';

    this.setState({
      property: value.toString().slice(0, 45),
      idProperty: '',
      selectedPropertyIds: [],
      showCustomProperty: true,
      obs: ''
    });
  };

  handleCustomPropertyChange = (event) => {
    const checked = event && event.target ? event.target.checked : false;

    this.setState({
      showCustomProperty: checked,
      property: '',
      idProperty: '',
      selectedPropertyIds: [],
      obs: '',
      address: checked ? this.state.address : this.getClientAddress(this.state.idClient)
    });
  };

  openPropertyModal = (event) => {
    if (event && event.preventDefault) event.preventDefault();
    if (event && event.stopPropagation) event.stopPropagation();

    this.setState({
      showPropertyForm: true,
      idProperty: '',
      propertyModalKey: Date.now()
    });
  };

  closePropertyModal = () => {
    this.setState({
      showPropertyForm: false
    });
  };

  saveProperty = (savedProperty) => {
    const selectedClientId = this.state.idClient;
    const previousProperties = Array.isArray(this.state.properties) ? [...this.state.properties] : [];

    if (!selectedClientId) {
      this.setState({
        showPropertyForm: false
      });
      return;
    }

    this.readProperties(selectedClientId, (propertyList) => {
      const safePropertyList = Array.isArray(propertyList) ? propertyList : [];

      let selectedProperty = null;

      if (savedProperty && savedProperty.id) {
        selectedProperty = safePropertyList.find((item) => item && Number(item.id) === Number(savedProperty.id)) || null;
      }

      if (!selectedProperty) {
        const previousIds = previousProperties
          .filter((item) => item && item.id != null)
          .map((item) => item.id);

        selectedProperty = safePropertyList.find((item) => item && item.id != null && previousIds.indexOf(item.id) === -1) || null;
      }

      if (!selectedProperty && safePropertyList.length > 0) {
        selectedProperty = safePropertyList[safePropertyList.length - 1];
      }

      if (selectedProperty) {
        this.setState({
          ...this.getSelectedPropertyState([selectedProperty]),
          showPropertyForm: false,
          properties: safePropertyList
        });
      } else {
        this.setState({
          showPropertyForm: false,
          properties: safePropertyList
        });
      }
    });
  };

  handleChangeDetails = (name) => (event) => {
    const value = event.target.value;
    this.setTrabalhoValor(`equipment.details.${name}`, value);
  };

  renderEquipmentDetailsInput = () => {
    const trab = this.getTrabalho();
    const eq = trab?.equipment || {};
    const tipo = eq.type || '';
    if (!tipo) return null;

    const NameField = (
      <TextField
        id="equipment"
        label={this.props.res.EQUIPAMENTO}
        style={{ marginTop: '1rem', width: '50%', paddingRight: '1rem' }}
        value={eq.name || ''}
        onChange={this.onTrabalhoChange('equipment.name')}
      />
    );

    const Det = (id, label, key, noPadRight) => (
      <TextField
        id={id}
        label={label}
        style={{ marginTop: '1rem', width: '50%', paddingRight: noPadRight ? '0' : '1rem' }}
        value={(eq.details && eq.details[key]) ? eq.details[key] : ''}
        onChange={this.onTrabalhoChange('equipment.details.' + key)}
      />
    );

    switch (tipo) {
      case 'bicoHidraulicoCoreDisco':
        return (<div style={{ display: 'flex' }}>{NameField}{Det('core', this.props.res.CORE, 'core')}{Det('disco', this.props.res.DISCO, 'disco')}<TextField id="angulo" label={this.props.res.ANGULO} style={{ marginTop: '1rem', width: '50%' }} value={(eq.details && eq.details.angulo) ? eq.details.angulo : ''} onChange={this.onTrabalhoChange('equipment.details.angulo')} /></div>);
      case 'bicoHidraulicoCeramica':
        return (<div style={{ display: 'flex' }}>{NameField}{Det('ponta', this.props.res.PONTA, 'ponta')}<TextField id="angulo" label={this.props.res.ANGULO} style={{ marginTop: '1rem', width: '50%' }} value={(eq.details && eq.details.angulo) ? eq.details.angulo : ''} onChange={this.onTrabalhoChange('equipment.details.angulo')} /></div>);
      case 'atomizadorTela':
        return (<div style={{ display: 'flex' }}>{NameField}{Det('anguloPa', this.props.res.ANGULO_PA, 'anguloPa')}{Det('malha', this.props.res.MALHA, 'malha')}<TextField id="vru" label={this.props.res.VRU} style={{ marginTop: '1rem', width: '50%' }} value={(eq.details && eq.details.vru) ? eq.details.vru : ''} onChange={this.onTrabalhoChange('equipment.details.vru')} /></div>);
      case 'atomizadorDisco':
        return (<div style={{ display: 'flex' }}>{NameField}{Det('anguloPa', this.props.res.ANGULO_PA, 'anguloPa')}<TextField id="vru" label={this.props.res.VRU} style={{ marginTop: '1rem', width: '50%' }} value={(eq.details && eq.details.vru) ? eq.details.vru : ''} onChange={this.onTrabalhoChange('equipment.details.vru')} /></div>);
      case 'bicoHidraulicoSolido':
        return (<div style={{ display: 'flex' }}>{NameField}{Det('ponta', this.props.res.PONTA, 'ponta')}<TextField id="angulo" label={this.props.res.ANGULO} style={{ marginTop: '1rem', width: '50%' }} value={(eq.details && eq.details.angulo) ? eq.details.angulo : ''} onChange={this.onTrabalhoChange('equipment.details.angulo')} /></div>);
      case 'bicoHidraulicoPlano':
        return (<div style={{ display: 'flex' }}>{NameField}{Det('ponta', this.props.res.PONTA, 'ponta')}<TextField id="angulo" label={this.props.res.ANGULO} style={{ marginTop: '1rem', width: '50%' }} value={(eq.details && eq.details.angulo) ? eq.details.angulo : ''} onChange={this.onTrabalhoChange('equipment.details.angulo')} /></div>);
      case 'cp03tt03':
        return (<div style={{ display: 'flex' }}>{NameField}{Det('orificio', this.props.res.ORIFICIO, 'orificio')}<TextField id="angulo" label={this.props.res.ANGULO} style={{ marginTop: '1rem', width: '50%' }} value={(eq.details && eq.details.angulo) ? eq.details.angulo : ''} onChange={this.onTrabalhoChange('equipment.details.angulo')} /></div>);
      case 'cp11tt11':
        return (<div style={{ display: 'flex' }}>{NameField}{Det('ponta', this.props.res.PONTA, 'ponta')}<TextField id="angulo" label={this.props.res.ANGULO} style={{ marginTop: '1rem', width: '50%' }} value={(eq.details && eq.details.angulo) ? eq.details.angulo : ''} onChange={this.onTrabalhoChange('equipment.details.angulo')} /></div>);
      case 'cp09tt09':
        return (<div style={{ display: 'flex' }}>{NameField}{Det('orificio', this.props.res.ORIFICIO, 'orificio')}<TextField id="angulo" label={this.props.res.ANGULO} style={{ marginTop: '1rem', width: '50%' }} value={(eq.details && eq.details.angulo) ? eq.details.angulo : ''} onChange={this.onTrabalhoChange('equipment.details.angulo')} /></div>);
      case 'outro':
        return (<div style={{ display: 'flex' }}>{NameField}{Det('ponta', this.props.res.PONTA, 'ponta')}<TextField id="angulo" label={this.props.res.ANGULO} style={{ marginTop: '1rem', width: '50%' }} value={(eq.details && eq.details.angulo) ? eq.details.angulo : ''} onChange={this.onTrabalhoChange('equipment.details.angulo')} /></div>);
      default:
        return null;
    }
  };

  handleChangeTab = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };


  getPrefilledClientFromNavigation = () => {
    let prefilledClient = null;
    const queryData = (this.props && this.props.query) ? this.props.query : {};

    if (queryData.prefilledClient) {
      if (typeof queryData.prefilledClient === 'string') {
        try {
          prefilledClient = JSON.parse(queryData.prefilledClient);
        } catch (_) { }
      } else {
        prefilledClient = queryData.prefilledClient;
      }
    }

    if (!prefilledClient) {
      try {
        const saved = sessionStorage.getItem('serviceOrderPrefillClient');
        if (saved) {
          prefilledClient = JSON.parse(saved);
        }
      } catch (_) { }
    }

    if (!prefilledClient) {
      return null;
    }

    return {
      id: prefilledClient.id ? prefilledClient.id : (prefilledClient.id_client ? prefilledClient.id_client : ''),
      name: prefilledClient.name ? prefilledClient.name : (prefilledClient.client ? prefilledClient.client : ''),
      id_property: prefilledClient.id_property ? prefilledClient.id_property : (prefilledClient.idProperty ? prefilledClient.idProperty : ''),
      property: prefilledClient.property ? prefilledClient.property : ''
    };
  };

  getPrefilledAreasFromNavigation = () => {
    let prefilledAreas = [];
    const queryData = (this.props && this.props.query) ? this.props.query : {};

    if (Array.isArray(queryData.prefilledAreas)) {
      prefilledAreas = queryData.prefilledAreas;
    } else if (typeof queryData.prefilledAreas === 'string' && queryData.prefilledAreas.trim() !== '') {
      try {
        const parsed = JSON.parse(queryData.prefilledAreas);
        if (Array.isArray(parsed)) {
          prefilledAreas = parsed;
        }
      } catch (_) { }
    }

    if (!prefilledAreas.length) {
      try {
        const saved = sessionStorage.getItem('serviceOrderPrefillAreas');
        if (saved) {
          const parsed = JSON.parse(saved);
          if (Array.isArray(parsed)) {
            prefilledAreas = parsed;
          }
        }
      } catch (_) { }
    }

    const normalized = [];
    for (let i = 0; i < prefilledAreas.length; i++) {
      const area = prefilledAreas[i];
      if (!area) {
        continue;
      }

      let pointsPlace = '[]';
      if (typeof area.points_place === 'string' && area.points_place.trim() !== '') {
        pointsPlace = area.points_place;
      } else if (typeof area.points === 'string' && area.points.trim() !== '') {
        pointsPlace = area.points;
      } else if (Array.isArray(area.points_place)) {
        pointsPlace = JSON.stringify(area.points_place);
      } else if (Array.isArray(area.points)) {
        pointsPlace = JSON.stringify(area.points);
      }

      normalized.push({
        guid: area.guid || ('prefill-area-' + Date.now() + '-' + i),
        name: area.name || '',
        lat: area.lat != null ? String(area.lat) : '',
        lng: area.lng != null ? String(area.lng) : '',
        points_place: pointsPlace,
        id_client: area.id_client || '',
        id_property: area.id_property || '',
        type: 'area'
      });
    }

    return normalized;
  };

  getPrefilledPointsFromNavigation = () => {
    let prefilledPoints = [];
    const queryData = (this.props && this.props.query) ? this.props.query : {};

    if (Array.isArray(queryData.prefilledPoints)) {
      prefilledPoints = queryData.prefilledPoints;
    } else if (typeof queryData.prefilledPoints === 'string' && queryData.prefilledPoints.trim() !== '') {
      try {
        const parsed = JSON.parse(queryData.prefilledPoints);
        if (Array.isArray(parsed)) {
          prefilledPoints = parsed;
        }
      } catch (_) { }
    }

    if (!prefilledPoints.length) {
      try {
        const saved = sessionStorage.getItem('serviceOrderPrefillPoints');
        if (saved) {
          const parsed = JSON.parse(saved);
          if (Array.isArray(parsed)) {
            prefilledPoints = parsed;
          }
        }
      } catch (_) { }
    }

    const normalized = [];
    for (let i = 0; i < prefilledPoints.length; i++) {
      const point = prefilledPoints[i];
      if (!point) {
        continue;
      }

      let pointsPlace = '[]';
      if (typeof point.points_place === 'string' && point.points_place.trim() !== '') {
        pointsPlace = point.points_place;
      } else if (Array.isArray(point.points_place)) {
        pointsPlace = JSON.stringify(point.points_place);
      } else if (point.lat != null && point.lng != null) {
        pointsPlace = JSON.stringify([[Number(point.lat), Number(point.lng)]]);
      }

      normalized.push({
        guid: point.guid || ('prefill-point-' + Date.now() + '-' + i),
        name: point.name || '',
        lat: point.lat != null ? String(point.lat) : '',
        lng: point.lng != null ? String(point.lng) : '',
        points_place: pointsPlace,
        img_place: point.img_place || '',
        type: 'point'
      });
    }

    return normalized;
  };

  openPrefilledAreasService = () => {
    const prefilledAreas = this.getPrefilledAreasFromNavigation();
    const prefilledPoints = this.getPrefilledPointsFromNavigation();
    const prefilledClient = this.getPrefilledClientFromNavigation();

    if (!prefilledAreas.length && !prefilledPoints.length) {
      return;
    }

    const today = new Date().toLocaleDateString('sv-SE');

    const novo = this.normalizeTrabalho({
      id: Date.now(),
      dateTimeTrabalho: today,
      statusService: 'Aberto',
      cultura: '',
      turno: { manha: false, tarde: false },
      typeApp: { liquid: false, solid: false },
      typeService: {
        insecticide: false,
        herbicide: false,
        fungicide: false,
        seeding: false,
        fertilizing: false,
        maturator: false
      },
      areaRisk: { app: false, bee: false, others: false },
      areaRistOutro: '',
      plane: '',
      planeId: null,
      pilot: '',
      pilotId: null,
      pilotPhone: '',
      pilotCanac: '',
      pilotEmail: '',
      sizeArea: '',
      fluxo: '',
      larguraFaixa: '',
      application_speed: '',
      travel_speed: '',
      balloon_speed: '',
      flow_rate: '',
      hopper_load: '',
      swath_width: '',
      flight_height: '',
      balloon_width: '',
      balloon_length: '',
      espGota: '',
      qualidadeAgua: '',
      quantidadeLitrosKg: '',
      equipment: { type: '', name: '', details: {} },
      list_prod: [],
      list_form: [],
      list_areas: prefilledAreas,
      list_points: prefilledPoints,
      finance: {
        valuePerHa: '',
        paymentMethod: '',
        dueDate: '',
        confirmPayment: false,
        paymentDate: '',
        discountEnabled: false,
        discountValue: '',
        discountPercent: ''
      }
    });

    this.computeAndSetSizeArea(novo.list_areas, (value) => {
      novo.sizeArea = value;
    });

    this.setState({
      tabValue: 1,
      modalOpen: true,
      editIndex: null,
      jobs: novo
    }, () => {
      this.applyPrefilledClient(prefilledClient);
    });

    try {
      sessionStorage.removeItem('serviceOrderPrefillAreas');
      sessionStorage.removeItem('serviceOrderPrefillPoints');
    } catch (_) { }
  };

  getTrabalho = () => this.state.jobs;

  setTrabalhoValor = (path, value) => {
    this.setState(prevState => {
      const jobs = this.deepClone(prevState.jobs);
      const keys = path.split('.');
      let ref = jobs;
      for (let i = 0; i < keys.length - 1; i++) {
        const k = keys[i];
        if (ref[k] === undefined || typeof ref[k] !== 'object' || ref[k] === null) ref[k] = {};
        ref = ref[k];
      }
      ref[keys[keys.length - 1]] = Array.isArray(value) ? [...value] : value;
      return { jobs };
    });
  };

  normalizePlaneName = (name) => {
    return String(name || '').trim();
  };

  getSelectedPlaneNames = (selectedNames) => {
    const list = Array.isArray(selectedNames) ? selectedNames : [];
    const names = [];

    for (let i = 0; i < list.length; i++) {
      const name = this.normalizePlaneName(list[i]);
      if (name && names.indexOf(name) < 0) {
        names.push(name);
      }
    }

    return names;
  };

  applyPlaneConfigToJob = (selectedNames) => {
    const names = this.getSelectedPlaneNames(selectedNames);

    this.setState(prevState => {
      const jobs = this.deepClone(prevState.jobs);
      jobs.plane = names.join(', ');
      jobs.planeId = null;

      const getValue = (field) => {
        for (let i = 0; i < names.length; i++) {
          const selectedName = names[i];
          const plane = prevState.planes.find(item => this.normalizePlaneName(item.name) === selectedName);
          if (plane && plane[field]) {
            return plane[field];
          }
        }
        return '';
      };

      jobs.fluxo = getValue('flow_rate');
      jobs.larguraFaixa = getValue('swath_width');
      jobs.application_speed = getValue('application_speed');
      jobs.travel_speed = getValue('travel_speed');
      jobs.balloon_speed = getValue('balloon_speed');
      jobs.flow_rate = getValue('flow_rate');
      jobs.hopper_load = getValue('hopper_load');
      jobs.swath_width = getValue('swath_width');
      jobs.flight_height = getValue('flight_height');
      jobs.balloon_width = getValue('balloon_width');
      jobs.balloon_length = getValue('balloon_length');

      return { jobs, isRel: false };
    });
  };

  onTrabalhoChange = (path) => (event) => {
    const value = event && event.target ? event.target.value : event;

    if (path === 'plane') {
      this.applyPlaneConfigToJob(value ? [value] : []);
      return;
    }

    this.setTrabalhoValor(path, value);
  };

  toggleTrabalhoCheck = (group, key) => () => {
    const jobs = this.deepClone(this.state.jobs);
    if (!jobs[group]) jobs[group] = {};
    jobs[group][key] = !jobs[group][key];
    this.setState({ jobs });
  };

  normalizeTrabalho = (t) => {
    const job = this.deepClone(t || {});
    if (!job.equipment) job.equipment = { type: '', name: '', details: {} };
    if (typeof job.equipment.details !== 'object' || job.equipment.details === null) job.equipment.details = {};
    job.equipment.details = {
      core: '', disco: '', angulo: '', ponta: '',
      anguloPa: '', malha: '', vru: '', orificio: '',
      ...job.equipment.details
    };
    if (typeof job.equipment.name !== 'string') job.equipment.name = '';
    if (typeof job.equipment.type !== 'string') job.equipment.type = '';
    if (job.application_speed === undefined || job.application_speed === null) job.application_speed = '';
    if (job.travel_speed === undefined || job.travel_speed === null) job.travel_speed = '';
    if (job.balloon_speed === undefined || job.balloon_speed === null) job.balloon_speed = '';
    if (job.flow_rate === undefined || job.flow_rate === null) job.flow_rate = '';
    if (job.hopper_load === undefined || job.hopper_load === null) job.hopper_load = '';
    if (job.swath_width === undefined || job.swath_width === null) job.swath_width = '';
    if (job.flight_height === undefined || job.flight_height === null) job.flight_height = '';
    if (job.balloon_width === undefined || job.balloon_width === null) job.balloon_width = '';
    if (job.balloon_length === undefined || job.balloon_length === null) job.balloon_length = '';
    return job;
  };

  abrirModalTrabalho = (index = null) => {
    const toStr = (v) => (v == null ? '' : String(v));
    const isNonEmpty = (v) => v !== undefined && v !== null && String(v).trim() !== '';
    const norm = (s) => String(s || '').normalize('NFD').replace(/\p{Diacritic}/gu, '').toLowerCase();

    const areaRiskFromPlan = (() => {
      const out = { app: false, bee: false, others: false };
      const list = (this.planData?.planningAreaRiskList || []).map(toStr);
      if (list.some(v => norm(v) === 'app')) out.app = true;
      if (list.some(v => norm(v) === 'abelhas')) out.bee = true;
      const known = new Set(['app', 'abelhas']);
      if (list.some(v => !known.has(norm(v)))) out.others = true;
      return out;
    })();

    const typeServiceFromPlan = (() => {
      const list = (this.planData?.planningTypeServiceList || []).map(toStr);
      return {
        insecticide: list.some(v => norm(v) === 'inseticida'),
        herbicide: list.some(v => norm(v) === 'herbicida'),
        fungicide: list.some(v => norm(v) === 'fungicida'),
        seeding: list.some(v => ['semeadura', 'seeding'].includes(norm(v))),
        fertilizing: list.some(v => ['adubacao', 'fertilizing'].includes(norm(v))),
        maturator: list.some(v => ['maturador', 'maturator'].includes(norm(v))),
      };
    })();

    const typeAppFromPlan = (() => {
      const t = norm(this.planData?.planningTypeApplicationNorm || this.planData?.planningTypeApplication || '');
      return { liquid: ['liquido', 'líquido', 'liquid'].includes(t), solid: ['solido', 'sólido', 'solid'].includes(t) };
    })();

    const culturaFromPlan = (this.planData?.planningAgricultureCultureList || [])[0] || '';
    const fluxoFromAnalise = this.anaData?.flowMode || '';

    const planningProductList = Array.isArray(this.planData?.planningProductList) ? this.planData.planningProductList : [];
    const allProds = Array.isArray(this.state.list_all_prod) ? this.state.list_all_prod : [];
    const normEq = (s) => norm(s).replace(/\s+/g, ' ');
    const listProds = planningProductList
      .map((nameRaw) => {
        const name = String(nameRaw || '').trim();
        if (!name) return null;
        return allProds.find(p => normEq(p?.name || p?.description || '') === normEq(name)) ??
          { id: null, name };
      })
      .filter(Boolean)
      .map(p => ({ id: p.id, name: p.name || '' }));

    const pilotName = toStr(this.exeData?.pilot || this.planData?.pilot || '');
    const planeName = toStr(this.exeData?.plane || this.planData?.plane || '');
    const pilots = Array.isArray(this.state.pilots) ? this.state.pilots : [];
    const planes = Array.isArray(this.state.planes) ? this.state.planes : [];
    const pilotHit = pilotName ? (pilots.find(p => norm(p?.name) === norm(pilotName)) || null) : null;
    const planeHit = planeName ? (planes.find(p => norm(p?.name) === norm(planeName)) || null) : null;

    if (index === null || index === undefined) {
      const today = new Date().toLocaleDateString('sv-SE');
      const fromOrigin = (selector) => {
        const sel = (src) => (src ? selector(src) : undefined);
        const a = sel(this.exeData); if (isNonEmpty(a)) return a;
        const b = sel(this.planData); return (b !== undefined && b !== null) ? b : '';
      };

      const areaFromOrigin = fromOrigin((src) => (src.area_polygon ?? src.area_spray));
      const litersFromOrigin = String(fromOrigin((src) => (src.liters != null ? src.liters : '')) || '');
      const dateOnlyOrigin = String(fromOrigin((src) => src.startDate || '') || '');

      const novo = this.normalizeTrabalho({
        id: Date.now(),
        dateTimeTrabalho: dateOnlyOrigin || today,
        statusService: 'Aberto',
        cultura: culturaFromPlan || '',
        turno: { manha: false, tarde: false },
        typeApp: { ...typeAppFromPlan },
        typeService: { ...typeServiceFromPlan },
        areaRisk: { ...areaRiskFromPlan },
        areaRistOutro: '',
        plane: planeName,
        planeId: planeHit?.id || null,
        pilot: pilotName,
        pilotId: pilotHit?.id || null,
        pilotPhone: pilotHit ? (pilotHit.phone || pilotHit.fone || pilotHit.cellphone || pilotHit.celular || pilotHit.telefone || pilotHit.whatsapp || '') : '',
        pilotCanac: pilotHit?.canac || '',
        pilotEmail: pilotHit?.email || '',
        sizeArea: isNonEmpty(areaFromOrigin) ? String(areaFromOrigin) : '',
        fluxo: fluxoFromAnalise,
        larguraFaixa: '',
        espGota: '',
        qualidadeAgua: '',
        quantidadeLitrosKg: litersFromOrigin,
        equipment: { type: '', name: '', details: {} },
        list_prod: listProds,
        list_form: [],
        list_areas: [],
        list_points: [],
        finance: {
          valuePerHa: '',
          paymentMethod: '',
          dueDate: '',
          confirmPayment: false,
          paymentDate: '',
          discountEnabled: false,
          discountValue: '',
          discountPercent: ''
        }
      });

      if (!novo.sizeArea || Number(novo.sizeArea) <= 0) this.computeAndSetSizeArea(novo.list_areas, (v) => { novo.sizeArea = v; });

      this.setState({ modalOpen: true, editIndex: null, jobs: novo });
    } else {
      const existente = this.normalizeTrabalho(this.deepClone(this.state.jobsData[index]));
      if (!existente.sizeArea || Number(existente.sizeArea) <= 0) this.computeAndSetSizeArea(existente.list_areas, (v) => { existente.sizeArea = v; });
      this.setState({ modalOpen: true, editIndex: index, jobs: existente });
    }
  };

  computeAndSetSizeArea = (listAreas, apply) => {
    const parsePolygonLatLng = (pointsPlace) => {
      try {
        const rawPoints = typeof pointsPlace === 'string' ? JSON.parse(pointsPlace) : pointsPlace;
        const rawArray = Array.isArray(rawPoints) ? rawPoints : [];

        const latLngPoints = rawArray
          .map(p => (Array.isArray(p) ? p : null))
          .filter(p => p && Number.isFinite(+p[0]) && Number.isFinite(+p[1]))
          .map(p => [Number(p[0]), Number(p[1])]);

        if (latLngPoints.length >= 2) {
          const firstLat = latLngPoints[0][0];
          const firstLng = latLngPoints[0][1];
          const lastLat = latLngPoints[latLngPoints.length - 1][0];
          const lastLng = latLngPoints[latLngPoints.length - 1][1];

          if (firstLat === lastLat && firstLng === lastLng) {
            latLngPoints.pop();
          }
        }

        return latLngPoints;
      } catch (e) {
        return [];
      }
    };

    const computePolygonAreaInHectares = (latLngPoints) => {
      if (!Array.isArray(latLngPoints) || latLngPoints.length < 3) return 0;

      const earthRadiusMeters = 6371008.8;

      const averageLatitude = latLngPoints.reduce((sum, p) => sum + p[0], 0) / latLngPoints.length;
      const averageLatitudeRad = averageLatitude * Math.PI / 180;

      const toLocalXYMeters = (latLng) => {
        const lat = latLng[0];
        const lng = latLng[1];

        const xMeters = earthRadiusMeters * (lng * Math.PI / 180) * Math.cos(averageLatitudeRad);
        const yMeters = earthRadiusMeters * (lat * Math.PI / 180);

        return [xMeters, yMeters];
      };

      const xyMeters = latLngPoints.map(toLocalXYMeters);
      xyMeters.push(xyMeters[0]);

      let signedAreaMeters2 = 0;
      for (let i = 0; i < xyMeters.length - 1; i++) {
        signedAreaMeters2 +=
          xyMeters[i][0] * xyMeters[i + 1][1] -
          xyMeters[i + 1][0] * xyMeters[i][1];
      }

      const areaMeters2 = Math.abs(signedAreaMeters2) / 2;
      const areaHectares = areaMeters2 / 10000;

      return areaHectares;
    };

    const areasList = Array.isArray(listAreas) ? listAreas : [];

    const totalAreaHectares = areasList.reduce((acc, areaItem) => {
      const pointsPlace = areaItem && areaItem.points_place ? areaItem.points_place : '[]';
      const latLngPoints = parsePolygonLatLng(pointsPlace);
      return acc + computePolygonAreaInHectares(latLngPoints);
    }, 0);

    const sizeAreaValue = totalAreaHectares > 0 ? Number(totalAreaHectares).toFixed(2) : '';

    if (typeof apply === 'function') {
      apply(sizeAreaValue);
      if (typeof this.selectedProductsTotals === 'function') {
        setTimeout(() => this.selectedProductsTotals(), 0);
      }
    } else {
      this.setTrabalhoValor('sizeArea', sizeAreaValue);
      if (typeof this.selectedProductsTotals === 'function') {
        setTimeout(() => this.selectedProductsTotals(), 0);
      }
    }
  };

  parsePointsFromPlace = (points_place) => {
    try {
      const raw = typeof points_place === 'string' ? JSON.parse(points_place) : points_place;
      const arr = Array.isArray(raw) ? raw : [];
      const pts = arr
        .map(p => Array.isArray(p) ? p : null)
        .filter(p => p && Number.isFinite(+p[0]) && Number.isFinite(+p[1]))
        .map(([lat, lng]) => [Number(lat), Number(lng)]);
      if (pts.length >= 2) {
        const [f0, f1] = pts[0];
        const [l0, l1] = pts[pts.length - 1];
        if (f0 === l0 && f1 === l1) pts.pop();
      }
      return pts;
    } catch {
      return [];
    }
  };

  areaHaOfPolygon = (latLngs) => {
    const pts = Array.isArray(latLngs) ? latLngs : [];
    if (pts.length < 3) return 0;
    const R = 6371008.8;
    const lat0 = pts.reduce((s, [lat]) => s + lat, 0) / pts.length;
    const lat0Rad = lat0 * Math.PI / 180;
    const toXY = ([lat, lng]) => {
      const x = R * (lng * Math.PI / 180) * Math.cos(lat0Rad);
      const y = R * (lat * Math.PI / 180);
      return [x, y];
    };
    const xy = pts.map(toXY);
    xy.push(xy[0]);
    let area2 = 0;
    for (let i = 0; i < xy.length - 1; i++) {
      area2 += xy[i][0] * xy[i + 1][1] - xy[i + 1][0] * xy[i][1];
    }
    const areaM2 = Math.abs(area2) / 2;
    return areaM2 / 10000;
  };

  calcAreasHaFromListAreas = (listAreas) => {
    const list = Array.isArray(listAreas) ? listAreas : [];
    let total = 0;
    for (const a of list) {
      const pts = this.parsePointsFromPlace(a?.points_place || '[]');
      if (pts.length >= 3) total += this.areaHaOfPolygon(pts);
    }
    return total;
  };

  formatHa = (ha) => (Number(ha || 0)).toFixed(2);

  writeFileMap = (track) => {
    const items = [];
    let seq = 1;

    for (let i = 0; i < track.features.length; i++) {
      const f = track.features[i];
      const isPoint = f.geometry.type === 'Point';
      const isPolygonLike = ['Polygon', 'GeometryCollection', 'MultiPolygon', 'LineString'].includes(f.geometry.type);
      if ((this.type_import === 'Points' && isPoint) || (this.type_import !== 'Points' && isPolygonLike)) {
        const name = f.properties?.name || f.properties?.recibo || `${this.props.AREA} ${seq++}`;
        items.push({ name, feature: f, index: i });
      }
    }

    const temp_import = {
      ...this.state.import,
      show: true,
      itens: items,
      selected: []
    };

    temp_import.update = (itens) => {
      const withGuids = (Array.isArray(itens) ? itens : []).map(x => ({ ...x, guid: tools.newGuid() }));
      const mapped = this.fileMap(withGuids);
      const targetList = (this.type_import === 'Points') ? 'list_points' : 'list_areas';
      this.setState(
        prev => ({ import: { ...prev.import, show: false } }),
        () => {
          const atual = Array.isArray(this.getTrabalho()[targetList]) ? this.getTrabalho()[targetList] : [];
          const novo = mapped.concat(atual);
          this.setTrabalhoValor(targetList, novo);
          if (targetList === 'list_areas') this.computeAndSetSizeArea(novo);
          this.showPro(false);
        }
      );
    };

    this.setState({ import: temp_import });
  };

  fecharModalTrabalho = () => {
    this.setState({ modalOpen: false, editIndex: null });
  };

  serviceOrderJobs = async () => {
    const { editIndex } = this.state;
    const lista = [...this.state.jobsData];
    const novoJob = this.deepClone(this.state.jobs);

    if (editIndex === null) lista.push(novoJob);
    else lista[editIndex] = novoJob;

    await new Promise((r) => this.setState({ jobsData: lista }, r));
    this.fecharModalTrabalho();

    await this.salvarTrabalho({ onlyJobs: true, silent: true });
  };

  excluirTrabalho = (i) => {
    const lista = [...this.state.jobsData];
    lista.splice(i, 1);
    this.setState({ jobsData: lista });
  };

  toNumber = (v) => {
    if (v === null || v === undefined || v === '') return 0;
    if (typeof v === 'number') return isNaN(v) ? 0 : v;
    const n = parseFloat(String(v).replace(/\./g, '').replace(',', '.'));
    return isNaN(n) ? 0 : n;
  };

  formatCurrency = (n) => {
    const v = (typeof n === 'number') ? n : this.toNumber(n);
    return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  };

  onlyDate = (s) => (s ? String(s).substring(0, 10) : '');

  computeJobFinance = (job) => {
    const area = this.toNumber(job?.sizeArea);
    const fin = job?.finance || {};
    const valuePerHa = this.toNumber(fin.valuePerHa);
    const gross = area * valuePerHa;

    const pct = this.toNumber(fin.discountPercent);
    const val = this.toNumber(fin.discountValue);

    let discountValue = 0;
    if (fin.discountEnabled) {
      if (pct > 0) {
        discountValue = Math.min(gross * (pct / 100), gross);
      } else if (val > 0) {
        discountValue = Math.min(val, gross);
      }
    }

    const net = Math.max(gross - discountValue, 0);
    return { area, valuePerHa, gross, discountValue, net };
  };

  calcFinanceTotalsFromJobs = () => {
    let totalHa = 0, totalGross = 0, totalDiscount = 0, totalNet = 0;
    const jobs = Array.isArray(this.state.jobsData) ? this.state.jobsData : [];
    for (let i = 0; i < jobs.length; i++) {
      const calc = this.computeJobFinance(jobs[i]);
      totalHa += calc.area;
      totalGross += calc.gross;
      totalDiscount += calc.discountValue;
      totalNet += calc.net;
    }
    return { totalHa, totalGross, totalDiscount, totalNet };
  };

  openFinanceEdit = (index) => {
    const jobs = [...this.state.jobsData];
    const job = { ...jobs[index] };
    if (!job.finance) {
      job.finance = {
        valuePerHa: '',
        paymentMethod: '',
        dueDate: '',
        confirmPayment: false,
        paymentDate: '',
        discountEnabled: false,
        discountValue: '',
        discountPercent: ''
      };
    }
    jobs[index] = job;
    this.setState({ jobsData: jobs, financeEditOpen: true, financeEditIndex: index });
  };

  closeFinanceEdit = () => {
    this.setState({ financeEditOpen: false, financeEditIndex: null });
  };

  onFinanceJobChange = (field) => (e) => {
    const value = e && e.target ? e.target.value : e;
    const { financeEditIndex } = this.state;
    const jobs = [...this.state.jobsData];
    const job = { ...jobs[financeEditIndex], finance: { ...(jobs[financeEditIndex].finance || {}) } };
    job.finance[field] = value;
    jobs[financeEditIndex] = job;
    this.setState({ jobsData: jobs });
  };

  toggleFinanceJob = (field) => () => {
    const { financeEditIndex } = this.state;
    const jobs = [...this.state.jobsData];
    const job = { ...jobs[financeEditIndex], finance: { ...(jobs[financeEditIndex].finance || {}) } };
    job.finance[field] = !job.finance[field];
    if (field === 'confirmPayment' && !job.finance[field]) job.finance.paymentDate = '';
    if (field === 'discountEnabled' && !job.finance[field]) { job.finance.discountValue = ''; job.finance.discountPercent = ''; }
    jobs[financeEditIndex] = job;
    this.setState({ jobsData: jobs });
  };

  onDiscountValueJobChange = (e) => {
    const v = e && e.target ? e.target.value : e;
    const { financeEditIndex } = this.state;
    const jobs = [...this.state.jobsData];
    const job = { ...jobs[financeEditIndex], finance: { ...(jobs[financeEditIndex].finance || {}) } };
    const calcBase = this.computeJobFinance({ ...job, finance: { ...job.finance, discountEnabled: false } });
    const valueNum = this.toNumber(v);
    const percent = calcBase.gross > 0 ? Math.min((valueNum / calcBase.gross) * 100, 100) : 0;

    job.finance.discountValue = v;
    job.finance.discountPercent = percent ? String(percent).replace('.', ',') : '';
    jobs[financeEditIndex] = job;
    this.setState({ jobsData: jobs });
  };

  onDiscountPercentJobChange = (e) => {
    const p = e && e.target ? e.target.value : e;
    const { financeEditIndex } = this.state;
    const jobs = [...this.state.jobsData];
    const job = { ...jobs[financeEditIndex], finance: { ...(jobs[financeEditIndex].finance || {}) } };
    const calcBase = this.computeJobFinance({ ...job, finance: { ...job.finance, discountEnabled: false } });
    const percentNum = this.toNumber(p);
    const clamped = Math.min(Math.max(percentNum, 0), 100);
    const value = calcBase.gross * (clamped / 100);

    job.finance.discountPercent = p;
    job.finance.discountValue = value ? String(value).replace('.', ',') : '';
    jobs[financeEditIndex] = job;
    this.setState({ jobsData: jobs });
  };

  saveFinanceJob = (applyToAll) => {
    const { financeEditIndex, jobsData } = this.state;
    const jobs = [...jobsData];

    const finBase = {
      valuePerHa: jobs[financeEditIndex]?.finance?.valuePerHa || '',
      paymentMethod: jobs[financeEditIndex]?.finance?.paymentMethod || '',
      dueDate: jobs[financeEditIndex]?.finance?.dueDate || '',
      confirmPayment: !!jobs[financeEditIndex]?.finance?.confirmPayment,
      paymentDate: jobs[financeEditIndex]?.finance?.paymentDate || '',
      discountEnabled: !!jobs[financeEditIndex]?.finance?.discountEnabled,
      discountPercent: jobs[financeEditIndex]?.finance?.discountPercent || '',
    };

    if (applyToAll) {
      for (let i = 0; i < jobs.length; i++) {
        const fin = { ...(jobs[i].finance || {}) };
        jobs[i].finance = {
          ...fin,
          ...finBase,
          discountValue: ''
        };
      }
    } else {
      jobs[financeEditIndex] = { ...jobs[financeEditIndex] };
    }

    this.setState({ jobsData: jobs }, this.closeFinanceEdit);
  };

  salvarTrabalho = async (opts) => {
    opts = opts || {};
    const onlyJobs = !!opts.onlyJobs;
    const silent = !!opts.silent;
    const skipReload = !!opts.skipReload;
    const skipServiceOrderPdfNotify = !!opts.skipServiceOrderPdfNotify;
    const skipServiceOrderAttachmentsNotify = !!opts.skipServiceOrderAttachmentsNotify;
    if (this.state.isSavingServiceOrder) return;

    this.setState({ isSavingServiceOrder: true });

    try {
      const isNonEmpty = (value) => value !== undefined && value !== null && String(value).trim() !== '';
      const toDecimal = (value) => {
        if (!isNonEmpty(value)) return 0;
        var v = String(value).trim();
        v = v.replace(/[^\d,.\-]/g, '');
        v = v.replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(',', '.');
        var n = Number(v);
        return isNaN(n) ? 0 : n;
      };
      const decimalOrNull = (value) => isNonEmpty(value) ? toDecimal(value) : null;
      const onlyDate = (value) => { if (!isNonEmpty(value)) return ''; var s = String(value); return s.length >= 10 ? s.substring(0, 10) : s; };
      const numberOrNull = (value) => (value === '' || value === undefined || value === null) ? null : Number(value);
      const validDbId = (value) => { var n = Number(value); return Number.isInteger(n) && n > 0 && n <= 2147483647; };
      const getExt = (name) => { if (!name) return null; var dot = name.lastIndexOf('.'); return dot > 0 ? name.substring(dot + 1).toLowerCase() : null; };
      const fileToBase64 = (file) => new Promise((resolve, reject) => {
        const r = new FileReader();
        r.onload = () => { const s = String(r.result || ''); const i = s.indexOf(','); resolve(i >= 0 ? s.substring(i + 1) : s); };
        r.onerror = (e) => reject(e);
        r.readAsDataURL(file);
      });

      const mapProductToPayload = (p, areaHa) => {
        if (!p) return null;
        const idMaster = Number(p.id_product != null ? p.id_product : p.idProduct);
        const idCustom = Number(p.id_product_custom != null ? p.id_product_custom : p.idProductCustom);
        const isCustom = (p.is_custom === true) || (String(p.source || '').toLowerCase() === 'custom') || (validDbId(idCustom));
        const dosage = String(p.dosage || '').trim();
        const unit = String(p.unit || '').trim();
        const d = Number(String(dosage).replace(',', '.'));
        const a = Number(areaHa);
        const total = (Number.isFinite(d) && Number.isFinite(a)) ? (d * a) : null;
        if (isCustom && validDbId(idCustom)) {
          return { id_product_custom: idCustom, is_custom: 1, dosage, dosage_per_ha: dosage, rate: dosage, unit, unit_measure: unit, total };
        }
        if (!isCustom && validDbId(idMaster)) {
          return { id: idMaster, id_product: idMaster, is_custom: 0, dosage, dosage_per_ha: dosage, rate: dosage, unit, unit_measure: unit, total };
        }
        return null;
      };

      const isEditing = !!this.state.id;

      var osOrigin = this.state.osOrigin;
      if (!osOrigin) {
        try { var saved = sessionStorage.getItem('jobOrigin'); if (saved) osOrigin = JSON.parse(saved); } catch (_) { }
      }
      const originGuid = osOrigin && osOrigin.job_guid ? String(osOrigin.job_guid) : null;
      const originJobId = osOrigin && osOrigin.job_id ? Number(osOrigin.job_id) : null;

      const planesState = Array.isArray(this.state.planes) ? this.state.planes : [];
      const planesById = {};
      const planesByName = {};
      for (let i = 0; i < planesState.length; i++) {
        const p = planesState[i];
        if (!p) continue;
        const pid = Number(p.id || p.id_plane || p.plane_id || p.idPlane || 0);
        if (validDbId(pid)) planesById[pid] = p;
        const pname = String(p.name || p.plane || p.prefix || p.registration || '').trim();
        if (pname) planesByName[pname.toLowerCase()] = p;
      }

      const jobsPayload = Array.isArray(this.state.jobsData) ? this.state.jobsData.map((jobData) => {
        const shiftParts = []; if (jobData.turno && jobData.turno.manha) shiftParts.push('Manha'); if (jobData.turno && jobData.turno.tarde) shiftParts.push('Tarde');
        const applicationTypes = []; if (jobData.typeApp && jobData.typeApp.liquid) applicationTypes.push('liquid'); if (jobData.typeApp && jobData.typeApp.solid) applicationTypes.push('solid');
        const agroUi = (jobData && jobData.agroClass && typeof jobData.agroClass === 'object') ? jobData.agroClass : (jobData && jobData.typeService && typeof jobData.typeService === 'object') ? jobData.typeService : {};
        const agroClassPayload = { insecticide: !!agroUi.insecticide, herbicide: !!agroUi.herbicide, fungicide: !!agroUi.fungicide, seeding: !!agroUi.seeding, fertilizing: !!agroUi.fertilizing, maturator: !!agroUi.maturator };
        const selectedService = String(jobData.selectedService || '').trim();
        const financeData = jobData.finance || {};
        const valuePerHectare = toDecimal(financeData.valuePerHa);
        const areaHectares = toDecimal(jobData.sizeArea);
        const discountValue = toDecimal(financeData.discountValue);
        const discountPercent = toDecimal(financeData.discountPercent);
        const grossTotal = areaHectares * valuePerHectare;
        const netTotal = Math.max(grossTotal - discountValue, 0);
        const productsPayload = Array.isArray(jobData.list_prod) ? jobData.list_prod.map((p) => mapProductToPayload(p, areaHectares)).filter(Boolean) : [];

        const selectedPlaneId = Number(jobData.id_plane || jobData.plane_id || jobData.planeId || (jobData.plane && jobData.plane.id) || 0);
        const selectedPlaneName = (typeof jobData.plane === 'string') ? String(jobData.plane).trim() : (jobData.plane && typeof jobData.plane === 'object') ? String(jobData.plane.name || jobData.plane.plane || jobData.plane.prefix || jobData.plane.registration || '').trim() : '';
        const planeNames = selectedPlaneName ? selectedPlaneName.split(',').map((name) => name.trim()).filter(Boolean) : [];
        let selectedPlane = null;

        for (let i = 0; i < planeNames.length; i++) {
          const planeNameKey = planeNames[i].toLowerCase();
          if (planeNameKey && planesByName[planeNameKey]) {
            selectedPlane = planesByName[planeNameKey];
            break;
          }
        }

        if (!selectedPlane && jobData.plane && typeof jobData.plane === 'object') {
          selectedPlane = jobData.plane;
        }

        const resolvedPlaneId = selectedPlane ? Number(selectedPlane.id || selectedPlane.id_plane || selectedPlane.plane_id || selectedPlane.idPlane || selectedPlaneId || 0) : selectedPlaneId;
        const resolvedPlaneCompanyId = selectedPlane ? Number(selectedPlane.company_id || selectedPlane.id_company || selectedPlane.companyId || 0) : 0;
        const resolvedPlaneNames = planeNames.length ? planeNames : (selectedPlaneName ? [selectedPlaneName] : []);
        const getJobPlaneParam = (jobField, planeField) => {
          if (isNonEmpty(jobData[jobField])) return decimalOrNull(jobData[jobField]);
          if (selectedPlane && isNonEmpty(selectedPlane[planeField])) return decimalOrNull(selectedPlane[planeField]);
          return null;
        };

        const jobObject = {
          status: jobData.statusService,
          job_date: onlyDate(jobData.dateTimeTrabalho),
          shift: shiftParts.join('/'),
          crop: jobData.cultura || '',
          application_type: applicationTypes.join('/'),
          service_type: selectedService,
          selected_service: selectedService,
          agro_class: JSON.stringify(agroClassPayload),

          plane: resolvedPlaneNames.length ? resolvedPlaneNames.join(', ') : ((typeof jobData.plane === 'string') ? jobData.plane : (selectedPlaneName || '')),
          id_plane: validDbId(resolvedPlaneId) ? resolvedPlaneId : null,
          plane_company_id: validDbId(resolvedPlaneCompanyId) ? resolvedPlaneCompanyId : null,
          plane_data: selectedPlane || null,
          pilot: jobData.pilot || '',
          pilotPhone: jobData.pilotPhone || '',
          pilot_canac: jobData.pilotCanac || '',
          pilot_email: jobData.pilotEmail || '',
          area: String(areaHectares),
          application_flow: String(toDecimal(jobData.fluxo)),
          strip_width: String(toDecimal(jobData.larguraFaixa)),
          application_speed: getJobPlaneParam('application_speed', 'application_speed'),
          travel_speed: getJobPlaneParam('travel_speed', 'travel_speed'),
          balloon_speed: getJobPlaneParam('balloon_speed', 'balloon_speed'),
          flow_rate: getJobPlaneParam('flow_rate', 'flow_rate'),
          hopper_load: getJobPlaneParam('hopper_load', 'hopper_load'),
          swath_width: getJobPlaneParam('swath_width', 'swath_width'),
          flight_height: getJobPlaneParam('flight_height', 'flight_height'),
          balloon_width: getJobPlaneParam('balloon_width', 'balloon_width'),
          balloon_length: getJobPlaneParam('balloon_length', 'balloon_length'),
          droplet_spectrum: jobData.espGota || '',
          water_quality: jobData.qualidadeAgua || '',
          quantity_liters_kilos: jobData.quantidadeLitrosKg || '',
          equipment: JSON.stringify(jobData.equipment || { type: '', name: '', details: {} }),
          risk_area: JSON.stringify(jobData.areaRisk || { app: false, bee: false, others: false }),
          products: productsPayload,
          list_prod: productsPayload,
          list_form: Array.isArray(jobData.list_form) ? jobData.list_form.map((form) => ({ id: Number(form.id) })) : [],
          list_areas: Array.isArray(jobData.list_areas) ? jobData.list_areas.map((area) => ({
            name: area.name || '',
            lat: numberOrNull(area.lat),
            lng: numberOrNull(area.lng),
            points_place: area.points_place || '',
            type: area.type || '',
            img_place: area.img_place || '',
            id: area.id ? Number(area.id) : ''
          })) : [],
          list_points: Array.isArray(jobData.list_points) ? jobData.list_points.map((point) => ({
            name: point.name || '',
            lat: numberOrNull(point.lat),
            lng: numberOrNull(point.lng),
            points_place: point.points_place || '',
            type: point.type || '',
            img_place: point.img_place || '',
            id: point.id ? Number(point.id) : ''
          })) : [],
          finance: {
            value_per_hectare: valuePerHectare,
            total_value_hectares: grossTotal,
            total_service_value: netTotal,
            payment_method: financeData.paymentMethod || '',
            payment_due_date: onlyDate(financeData.dueDate) || null,
            payment_date: onlyDate(financeData.paymentDate) || null,
            is_paid: financeData.confirmPayment ? 1 : 0,
            discount_value: discountValue,
            discount_percentage: discountPercent
          }
        };

        if (!validDbId(jobData.id)) {
          if (originJobId) jobObject.id_job = originJobId;
          if (originGuid) jobObject.job_guid = originGuid;
        }
        if (isEditing && validDbId(jobData.id)) jobObject.id = Number(jobData.id);
        return jobObject;
      }) : [];

      if (onlyJobs && this.state.id) {
        const baseSuspeitoVazio = !isNonEmpty(this.state.title) || !isNonEmpty(this.state.status) || !isNonEmpty(this.state.client) || !isNonEmpty(this.state.property);
        if (baseSuspeitoVazio && typeof this.readServiceOrderById === 'function') {
          await this.readServiceOrderById(this.state.id, true);
        }
      }

      const formData = new URLSearchParams();
      formData.append('source', 'portal');
      const addIf = (k, v) => { if (isNonEmpty(v)) formData.append(k, v); };

      addIf('title', this.state.title);
      addIf('order_number', this.state.serviceOrder);
      addIf('status', this.state.status);
      addIf('client', this.state.client);
      addIf('responsible', this.state.responsible);
      addIf('contact', this.state.contact);
      addIf('property', this.state.property);
      addIf('address', this.state.address);
      addIf('observation', this.state.obs);

      if (!onlyJobs) {
        formData.append('service_order_properties', JSON.stringify(this.buildServiceOrderPropertiesPayload()));
      }

      if (skipServiceOrderPdfNotify) {
        formData.append('skipServiceOrderPdfNotify', 'true');
      }
      if (skipServiceOrderAttachmentsNotify) {
        formData.append('skipServiceOrderAttachmentsNotify', 'true');
      }

      formData.append('jobs', JSON.stringify(jobsPayload));

      const signaturePayload = {
        technical_responsible: this.state.executor || '',
        cfta: this.state.executor_cfta_cpf || '',
        technical_responsible_email: this.state.executorEmail || '',
        client: this.state.client || '',
        client_email: this.state.clientEmail || ''
      };
      formData.append('signature', JSON.stringify(signaturePayload));

      if (osOrigin && (osOrigin.job_id || osOrigin.job_guid)) {
        formData.append('jobOrigin', JSON.stringify({
          job_id: osOrigin.job_id || undefined,
          job_guid: osOrigin.job_guid || undefined
        }));
      }

      const localAtts = Array.isArray(this.state.attachments) ? this.state.attachments : [];
      const files = localAtts.map((a) => a && a.file).filter((f) => f instanceof File);
      if (files.length) {
        const base64List = await Promise.all(files.map(fileToBase64));
        const attachmentsPayload = files.map((f, idx) => ({
          file_name: f.name || ('arquivo_' + (idx + 1)),
          file_ext: getExt(f.name),
          mime_type: f.type || 'application/octet-stream',
          size_bytes: f.size || 0,
          content_base64: base64List[idx]
        }));
        formData.append('attachments', JSON.stringify(attachmentsPayload));
      }

      if (!onlyJobs) {
        const removeIds = Array.isArray(this.state.attachmentsRemoveIds)
          ? this.state.attachmentsRemoveIds.filter(validDbId)
          : [];
        if (removeIds.length) {
          formData.append('attachments_remove_ids', JSON.stringify(removeIds));
        }
      }

      var apiUrl = (Config.server + '/service_order');
      var method = 'POST';
      if (this.state.id) {
        apiUrl += ('/' + this.state.id);
        formData.append('id', this.state.id);
        method = 'PUT';
      }

      const res = await fetch(apiUrl, { method: method, body: formData, headers: { 'Authorization': localStorage.getItem('access-token-jwt') } }).catch((e) => { throw e; });

      if (res.status !== 200) {
        if (res.status === 405) {
          if (!silent) notification.open({ message: this.props.res.PERMISSAO, description: this.props.res.PERMISSAO_MSG, icon: <MaterialIcon icon="error" className="text-danger" /> });
          return;
        }
        if (res.status === 401 || res.status === 403) { this.props.link('/login'); return; }
        if (res.status === 400) {
          const errCode = await res.json().catch(() => null);
          if (!silent) notification.open({ message: this.props.res[errCode && errCode.code ? errCode.code : 'ERRO'], icon: <MaterialIcon icon="error" className="text-danger" /> });
          return;
        }
        if (!silent) notification.open({ message: this.props.res.ERRO, description: this.props.res.ERRO_MSG, icon: <MaterialIcon icon="error" className="text-danger" /> });
        return;
      }

      const result = await res.json();
      const osIdFromServer = (result && (result.id_service_order || result.id)) ? Number(result.id_service_order || result.id) : null;
      const finalId = osIdFromServer || this.state.id;
      const serviceOrderIdToReload = (!this.state.id && osIdFromServer) ? finalId : this.state.id;
      const hasPlanningProcessing = !!(result && (result.planning_processing === true || result.planningProcessing === true));
      this.setPlanningProcessing(hasPlanningProcessing, finalId);

      if (!silent) {
        let successMessage = this.props.res.ITEM_INCLUIR;
        if (this.state.id) successMessage = this.props.res.ITEM_ALTERADO;
        notification.open({ message: this.props.res.SUCESSO, description: successMessage, icon: <MaterialIcon icon="check_circle" className="text-success" /> });
      }

      try { sessionStorage.removeItem('jobOrigin'); } catch (_) { }
      if (this.state.osOrigin) this.setState({ osOrigin: null });

      if (!onlyJobs && Array.isArray(this.state.attachmentsRemoveIds) && this.state.attachmentsRemoveIds.length) {
        this.setState({ attachmentsRemoveIds: [] });
      }

      if (!this.state.id && osIdFromServer) {
        var newUrl = '/app/ordem-servico/edit/' + String(finalId);

        await new Promise((resolve) => {
          this.setState({ id: finalId }, resolve);
        });

        try { this.props.link(newUrl, { replace: true }); } catch (_) { this.props.link(newUrl); }
      }

      if (!skipReload && typeof this.readServiceOrderById === 'function' && serviceOrderIdToReload) {
        await this.readServiceOrderById(serviceOrderIdToReload, true);
      }

      this.setState({ editForm: false, modalOpen: false, editIndex: null, financeEditOpen: false, financeEditIndex: null });
    } finally {
      this.setState({ isSavingServiceOrder: false });
    }
  };

  readServiceOrderById = (serviceOrderId, preserveSavingState) => {
    const currentId = serviceOrderId || this.state.id;
    const keepSavingState = preserveSavingState === true;
    const apiUrl = (Config.server + '/service_order/' + currentId);
    const options = { method: 'GET', headers: { 'Authorization': localStorage.getItem('access-token-jwt') } };

    if (!keepSavingState) {
      this.setState({ isSavingServiceOrder: true });
    }

    return fetch(apiUrl, options)
      .then(function (response) { if (response.status !== 200) throw response; return response.json(); })
      .then((result) => {
        const toNumOrNull = function (v) { const n = Number(v); return Number.isFinite(n) ? n : null; };
        const toStr = function (v) { return (v == null ? '' : String(v)); };
        const toDateOnly = function (v) {
          if (v == null) return '';
          const d = typeof v === 'number' ? new Date(v) : new Date(String(v));
          if (isNaN(d.getTime())) return '';
          const yyyy = d.getFullYear(); const mm = String(d.getMonth() + 1).padStart(2, '0'); const dd = String(d.getDate(), 10).padStart(2, '0');
          return (yyyy + '-' + mm + '-' + dd);
        };

        const jo = (this.props && this.props.jobOrigin) ? this.props.jobOrigin : {};
        const planRow = (jo && jo.job_list_plan && jo.job_list_plan[0]) ? jo.job_list_plan[0] : null;
        const exeRow = (jo && jo.job_list_exe && jo.job_list_exe[0]) ? jo.job_list_exe[0] : null;
        const anaRow = (jo && jo.job_list_analise && jo.job_list_analise[0]) ? jo.job_list_analise[0] : null;

        const parseJson = function (value, fallback) {
          if (value == null || value === '') return fallback;
          if (typeof value === 'object') return value;
          try { return JSON.parse(String(value)); } catch (e) { return fallback; }
        };
        const toStringSafe = function (value) { return (value == null ? '' : String(value)); };
        const parseList = function (raw) {
          if (raw == null) return [];
          if (Array.isArray(raw)) return raw.map(function (x) { return toStringSafe(x).trim(); }).filter(Boolean);
          const s = toStringSafe(raw).trim();
          if (!s) return [];
          try {
            const v = JSON.parse(s);
            if (Array.isArray(v)) return v.map(function (x) { return toStringSafe(x).trim(); }).filter(Boolean);
          } catch (e) { }
          return [s];
        };
        const parseProducts = function (input) {
          const arr = parseJson(input, null);
          if (!Array.isArray(arr)) return [];
          let preferValid = false;
          for (let i = 0; i < arr.length; i++) {
            const o = parseJson(arr[i], null);
            if (o && typeof o === 'object') {
              for (const k in o) {
                const meta = o[k];
                if (meta && typeof meta === 'object' && meta.isValid === true) { preferValid = true; break; }
              }
            }
            if (preferValid) break;
          }
          const out = []; const seen = Object.create(null);
          for (let i = 0; i < arr.length; i++) {
            const o = parseJson(arr[i], null);
            if (o && typeof o === 'object') {
              for (const k in o) {
                if (!k || seen[k]) continue;
                const meta = o[k];
                if (preferValid) {
                  if (meta && typeof meta === 'object' && meta.isValid === true) { out.push(k); seen[k] = true; }
                } else {
                  if (meta && typeof meta === 'object') {
                    const d = Number(meta.dosage); const t = Number(meta.total);
                    if ((Number.isFinite(d) && d > 0) || (Number.isFinite(t) && t > 0) || Object.keys(meta).length === 0) { out.push(k); seen[k] = true; }
                  } else { out.push(k); seen[k] = true; }
                }
              }
            }
          }
          return out;
        };
        const modeFromCSV = function (csv) {
          if (!csv) return null;
          const parts = String(csv).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
          if (!parts.length) return null;
          const counts = Object.create(null); const firstIdx = Object.create(null);
          let best = parts[0], bestCount = 0;
          for (let i = 0; i < parts.length; i++) {
            const v = parts[i]; counts[v] = (counts[v] || 0) + 1;
            if (firstIdx[v] == null) firstIdx[v] = i;
            if (counts[v] > bestCount || (counts[v] === bestCount && firstIdx[v] < firstIdx[best])) { best = v; bestCount = counts[v]; }
          }
          return best;
        };

        const ensureClientInList = function (clientList, clientName, clientEmail) {
          const name = toStringSafe(clientName).trim();
          if (!name) return Array.isArray(clientList) ? clientList : [];
          const list = Array.isArray(clientList) ? clientList.slice(0) : [];
          const exists = list.some(function (item) {
            if (!item) return false;
            const id = item.id != null ? String(item.id) : '';
            const nm = item.name != null ? String(item.name) : '';
            const label = item.label != null ? String(item.label) : '';
            const value = item.value != null ? String(item.value) : '';
            return id === name || nm === name || label === name || value === name;
          });
          if (exists) return list;
          const newClient = {
            id: 'shared_client_' + name,
            name: name,
            label: name,
            value: name,
            email: toStringSafe(clientEmail),
            fromShared: true
          };
          list.push(newClient);
          return list;
        };

        const ensureOptionInList = function (list, name, extra) {
          const text = toStringSafe(name).trim();
          if (!text) return Array.isArray(list) ? list : [];
          const arr = Array.isArray(list) ? list.slice(0) : [];
          const exists = arr.some(function (item) {
            if (!item) return false;
            const id = item.id != null ? String(item.id) : '';
            const nm = item.name != null ? String(item.name) : '';
            const label = item.label != null ? String(item.label) : '';
            const value = item.value != null ? String(item.value) : '';
            return id === text || nm === text || label === text || value === text;
          });
          if (exists) return arr;
          const prefix = extra && extra.prefix ? String(extra.prefix) : 'shared_';
          const newItem = {
            id: prefix + text,
            name: text,
            label: text,
            value: text
          };
          if (extra) {
            for (var k in extra) {
              if (k === 'prefix') continue;
              if (extra[k] != null) newItem[k] = extra[k];
            }
          }
          arr.push(newItem);
          return arr;
        };

        this.planData = planRow ? {
          id: (planRow.id != null ? planRow.id : null),
          guid: (planRow.guid != null ? planRow.guid : null),
          area_polygon: toNumOrNull(planRow.area_polygon),
          area_spray: toNumOrNull(planRow.area_spray),
          liters: toNumOrNull(planRow.liters),
          pilot: toStr(planRow.pilot),
          plane: toStr(planRow.plane),
          startDate: toDateOnly(planRow.startDate || planRow.datetime),
          title: toStr(planRow.title),
          type: (planRow.type != null ? planRow.type : 'planejamento'),
          planningTypeApplication: (planRow.planningTypeApplication != null ? planRow.planningTypeApplication : null),
          planningTypeService: (planRow.planningTypeService != null ? planRow.planningTypeService : null),
          planningEquipment: (planRow.planningEquipment != null ? planRow.planningEquipment : null),
          planningAgricultureCulture: (planRow.planningAgricultureCulture != null ? planRow.planningAgricultureCulture : null),
          planningProduct: (planRow.planningProduct != null ? planRow.planningProduct : null),
          planningAreaRisk: (planRow.planningAreaRisk != null ? planRow.planningAreaRisk : null),
          planningTypeApplicationNorm: ((planRow.planningTypeApplication == null || String(planRow.planningTypeApplication).trim() === '') ? null : String(planRow.planningTypeApplication).trim()),
          planningTypeServiceList: parseList(planRow.planningTypeService),
          planningAgricultureCultureList: parseList(planRow.planningAgricultureCulture),
          planningAreaRiskList: parseList(planRow.planningAreaRisk),
          planningProductList: parseProducts(planRow.planningProduct)
        } : null;

        this.exeData = exeRow ? {
          id: (exeRow.id != null ? exeRow.id : null),
          guid: (exeRow.guid != null ? exeRow.guid : null),
          area_polygon: toNumOrNull(exeRow.area_polygon),
          area_spray: toNumOrNull(exeRow.area_spray),
          liters: toNumOrNull(exeRow.liters),
          pilot: toStr(exeRow.pilot),
          plane: toStr(exeRow.plane),
          startDate: toDateOnly(exeRow.startDate || exeRow.datetime),
          title: toStr(exeRow.title),
          type: (exeRow.type != null ? exeRow.type : 'execucao')
        } : null;

        this.anaData = anaRow ? {
          id: (anaRow.id != null ? anaRow.id : null),
          guid: (anaRow.guid != null ? anaRow.guid : null),
          type: (anaRow.type != null ? anaRow.type : 'analise'),
          flow: (anaRow.flow != null ? String(anaRow.flow) : null),
          flowMode: modeFromCSV(anaRow.flow)
        } : null;

        const onlyDate2 = function (value) { return (value ? String(value).substring(0, 10) : ''); };
        const splitFlags = function (text) { return String(text || '').split('/').map(function (part) { return part.trim(); }).filter(Boolean); };
        const makeGuid = function (obj) {
          if (!obj) return '';
          if (obj.guid && String(obj.guid).trim() !== '') return String(obj.guid);
          if (obj.id != null && String(obj.id).trim() !== '') return String(obj.id);
          const normalized = [obj.name, obj.lat, obj.lng].map(function (v) { return (v == null ? '' : String(v)); }).join('|');
          return normalized || (Date.now().toString(36) + Math.random().toString(36).slice(2));
        };
        const fixed6 = function (value) { const numberValue = Number(value); if (!isFinite(numberValue)) return null; return parseFloat(numberValue.toFixed(6)); };

        const infoJob = function (arr) {
          return Array.isArray(arr) ? arr.map(function (data) {
            return {
              id: data.id,
              guid: data.guid,
              type: data.type,
              id_job: data.id_job,
              id_company_origin: data.id_company_origin,
              company_origin_name: data.company_origin_name,
              id_plane: data.id_plane,
              id_client: data.id_client,
              title: data.title,
              datetime: data.datetime,
              pilot: data.pilot,
              plane: data.plane,
              client: data.client,
              liters: data.liters,
              area_spray: data.area_spray,
              area_polygon: data.area_polygon,
              startDate: data.startDate,
              endDate: data.endDate,
              client_name: data.client_name,
              plane_name: data.plane_name,
              id_task: data.id_task,
              status_task: data.status_task,
              progress_task: data.progress_task,
              created_task: data.created_task,
              event: data.event || null
            };
          }) : [];
        };

        const jobsData = Array.isArray(result.jobs) ? result.jobs.map((jobRow) => {
          const shiftTokens = splitFlags(jobRow.shift);
          const turno = { manha: (shiftTokens.indexOf('Manha') >= 0 || shiftTokens.indexOf('Manhã') >= 0), tarde: (shiftTokens.indexOf('Tarde') >= 0) };
          const applicationTokens = splitFlags(jobRow.application_type);
          const typeApp = { liquid: (applicationTokens.indexOf('liquid') >= 0), solid: (applicationTokens.indexOf('solid') >= 0) };

          const agroFromJson = parseJson(jobRow.agro_class, null);
          let agroClass = null;

          if (agroFromJson && typeof agroFromJson === 'object') {
            agroClass = {
              insecticide: !!agroFromJson.insecticide,
              herbicide: !!agroFromJson.herbicide,
              fungicide: !!agroFromJson.fungicide,
              seeding: !!agroFromJson.seeding,
              fertilizing: !!agroFromJson.fertilizing,
              maturator: !!agroFromJson.maturator
            };
          } else {
            const rawAgro = toStringSafe(jobRow.agro_class || '');
            const toks = rawAgro.toLowerCase().split(/[\/,]/).map(function (s) { return s.trim(); }).filter(Boolean);
            if (toks.length) {
              const has = function (k) { return toks.indexOf(k) >= 0; };
              agroClass = {
                insecticide: has('insecticide'),
                herbicide: has('herbicide'),
                fungicide: has('fungicide'),
                seeding: has('seeding'),
                fertilizing: has('fertilizing'),
                maturator: has('maturator')
              };
            } else {
              agroClass = { insecticide: false, herbicide: false, fungicide: false, seeding: false, fertilizing: false, maturator: false };
            }
          }

          const rawServiceType = toStringSafe(jobRow.service_type || '');
          const validServices = { 'AplicacaoAgrotoxico': 1, 'AplicacaoFertilizante': 1, 'Semeadura': 1, 'Maturador': 1 };
          const selectedService = validServices[rawServiceType] ? rawServiceType : '';

          const finalAgroClass = agroClass;
          const typeService = {
            insecticide: !!finalAgroClass.insecticide,
            herbicide: !!finalAgroClass.herbicide,
            fungicide: !!finalAgroClass.fungicide,
            seeding: !!finalAgroClass.seeding,
            fertilizing: !!finalAgroClass.fertilizing,
            maturator: !!finalAgroClass.maturator,
          };

          const areaRisk = parseJson(jobRow.risk_area, { app: false, bee: false, others: false });
          const equipmentRaw = parseJson(jobRow.equipment, { type: '', name: '', details: {} });
          const equipment = {
            type: toStringSafe(equipmentRaw.type),
            name: toStringSafe(equipmentRaw.name),
            details: {
              core: toStringSafe((equipmentRaw.details || {}).core),
              disco: toStringSafe((equipmentRaw.details || {}).disco),
              angulo: toStringSafe((equipmentRaw.details || {}).angulo),
              ponta: toStringSafe((equipmentRaw.details || {}).ponta),
              anguloPa: toStringSafe((equipmentRaw.details || {}).anguloPa),
              malha: toStringSafe((equipmentRaw.details || {}).malha),
              vru: toStringSafe((equipmentRaw.details || {}).vru),
              orificio: toStringSafe((equipmentRaw.details || {}).orificio)
            }
          };

          const rawProducts =
            (Array.isArray(jobRow.products) ? jobRow.products : null) ||
            (Array.isArray(jobRow.list_prod) ? jobRow.list_prod : null) ||
            (Array.isArray(jobRow.job_products) ? jobRow.job_products : null) ||
            (Array.isArray(jobRow.products_list) ? jobRow.products_list : null) ||
            [];

          const normalizeReadProduct = function (p) {
            if (!p) return null;

            var idProduct = Number(p.id_product);
            var idProductCustom = Number(p.id_product_custom);
            var idGeneric = Number(p.id);

            var hintedCustom =
              (p.is_custom === true || p.is_custom === 1) ||
              (String(p.source || '').toLowerCase() === 'custom') ||
              (p.from_custom === true || p.from_custom === 1) ||
              (p.custom === 1);

            if ((!isFinite(idProductCustom) || idProductCustom <= 0) && hintedCustom && isFinite(idGeneric) && idGeneric > 0) {
              idProductCustom = idGeneric;
            }

            var isCustom = (isFinite(idProductCustom) && idProductCustom > 0) || hintedCustom;
            var source = isCustom ? 'custom' : 'master';

            var finalIdProduct = null;
            var finalIdProductCustom = null;

            if (source === 'master') {
              if (isFinite(idProduct) && idProduct > 0) finalIdProduct = idProduct;
              else if (!isCustom && isFinite(idGeneric) && idGeneric > 0) finalIdProduct = idGeneric;
            } else {
              if (isFinite(idProductCustom) && idProductCustom > 0) finalIdProductCustom = idProductCustom;
              else if (isFinite(idGeneric) && idGeneric > 0) finalIdProductCustom = idGeneric;
            }

            var idForUid = source === 'custom' ? finalIdProductCustom : finalIdProduct;
            var uid = (source + ':' + idForUid);

            return {
              uid: uid,
              source: source,
              idProduct: source === 'master' ? finalIdProduct : null,
              idProductCustom: source === 'custom' ? finalIdProductCustom : null,
              id: (isFinite(Number(p.id)) ? Number(p.id) : undefined),
              name: p.name,
              description: p.description,
              manufacturer: p.manufacturer,
              dosage: (p.dosage != null ? p.dosage : (p.dosage_per_ha != null ? p.dosage_per_ha : (p.rate != null ? p.rate : ''))),
              unit: (p.unit != null ? p.unit : (p.unit_measure != null ? p.unit_measure : '')),
              total: (p.total != null ? p.total : '')
            };
          };

          const list_prod = Array.isArray(rawProducts) ? rawProducts.map(normalizeReadProduct).filter(Boolean) : [];

          const list_form = Array.isArray(jobRow.formulations) ? jobRow.formulations.map(function (f) {
            return { id: f.id, cod: f.cod, description: f.description, type: f.type, name: (f.cod + ' - ' + f.description) };
          }) : [];

          const list_areas = Array.isArray(jobRow.areas) ? jobRow.areas.map(function (a) {
            return {
              guid: makeGuid(a),
              id: (a.id != null ? a.id : null),
              name: a.name || '',
              lat: fixed6(a.lat),
              lng: fixed6(a.lng),
              points_place: a.points_place || '',
              type: a.type || 'area',
              img_place: a.img_place || ''
            };
          }) : [];

          const list_points = Array.isArray(jobRow.points) ? jobRow.points.map(function (p) {
            return {
              guid: makeGuid(p),
              id: (p.id != null ? p.id : null),
              name: p.name || '',
              lat: fixed6(p.lat),
              lng: fixed6(p.lng),
              points_place: p.points_place || '',
              type: p.type || 'point',
              img_place: p.img_place || ''
            };
          }) : [];

          const financialRow = jobRow.financial || (Array.isArray(jobRow.financials) && jobRow.financials[0]) || {};
          const discountEnabled = !!(Number(financialRow.discount_value) || Number(financialRow.discount_percentage));
          const finance = {
            valuePerHa: toStringSafe((financialRow.value_per_hectare != null ? financialRow.value_per_hectare : '')),
            paymentMethod: toStringSafe(financialRow.payment_method || ''),
            dueDate: financialRow.payment_due_date ? onlyDate2(financialRow.payment_due_date) : '',
            confirmPayment: !!(financialRow.is_paid === 1 || financialRow.is_paid === true),
            paymentDate: financialRow.payment_date ? onlyDate2(financialRow.payment_date) : '',
            discountEnabled: discountEnabled,
            discountValue: toStringSafe((financialRow.discount_value != null ? financialRow.discount_value : '')),
            discountPercent: toStringSafe((financialRow.discount_percentage != null ? financialRow.discount_percentage : ''))
          };

          const areaSize = ((this.exeData && this.exeData.area_polygon != null) ? this.exeData.area_polygon : ((this.planData && this.planData.area_polygon != null) ? this.planData.area_polygon : null));
          const sizeArea = (toStringSafe((jobRow.area != null ? jobRow.area : '')) || (areaSize != null ? String(areaSize) : ''));

          return {
            id: jobRow.id,
            id_job: jobRow.id_job,
            id_job_link: jobRow.id_job_link,
            guid: jobRow.job_guid,
            aplication_guid: jobRow.aplication_guid,
            statusService: jobRow.status,
            dateTimeTrabalho: onlyDate2(jobRow.job_date),
            cultura: toStringSafe(jobRow.crop || ''),
            turno: turno,
            typeApp: typeApp,
            selectedService: selectedService,
            agroClass: finalAgroClass,
            typeService: typeService,
            areaRisk: areaRisk,
            areaRistOutro: '',
            plane: toStringSafe(jobRow.plane || ''),
            planeId: Number(jobRow.id_plane || jobRow.plane_id || 0) || null,
            pilot: toStringSafe(jobRow.pilot || ''),
            pilotId: Number(jobRow.id_pilot || jobRow.pilot_id || 0) || null,
            pilotPhone: toStringSafe(jobRow.pilotPhone || jobRow.pilot_phone || ''),
            pilotCanac: toStringSafe(jobRow.pilot_canac || ''),
            pilotEmail: toStringSafe(jobRow.pilot_email || ''),
            sizeArea: sizeArea,
            fluxo: toStringSafe((jobRow.application_flow != null ? jobRow.application_flow : '')),
            larguraFaixa: toStringSafe((jobRow.strip_width != null ? jobRow.strip_width : '')),
            application_speed: toStringSafe((jobRow.application_speed != null ? jobRow.application_speed : '')),
            travel_speed: toStringSafe((jobRow.travel_speed != null ? jobRow.travel_speed : '')),
            balloon_speed: toStringSafe((jobRow.balloon_speed != null ? jobRow.balloon_speed : '')),
            flow_rate: toStringSafe((jobRow.flow_rate != null ? jobRow.flow_rate : '')),
            hopper_load: toStringSafe((jobRow.hopper_load != null ? jobRow.hopper_load : '')),
            swath_width: toStringSafe((jobRow.swath_width != null ? jobRow.swath_width : '')),
            flight_height: toStringSafe((jobRow.flight_height != null ? jobRow.flight_height : '')),
            balloon_width: toStringSafe((jobRow.balloon_width != null ? jobRow.balloon_width : '')),
            balloon_length: toStringSafe((jobRow.balloon_length != null ? jobRow.balloon_length : '')),
            espGota: toStringSafe(jobRow.droplet_spectrum || ''),
            qualidadeAgua: toStringSafe(jobRow.water_quality || ''),
            quantidadeLitrosKg: toStringSafe((jobRow.quantity_liters_kilos != null ? jobRow.quantity_liters_kilos : '')),
            equipment: equipment,
            list_prod: list_prod,
            list_form: list_form,
            list_areas: list_areas,
            list_points: list_points,
            finance: finance,
            predocument_b64: jobRow.predocument_b64,
            documentRelMapab64: jobRow.documentRelMapab64,
            list_plan: infoJob(jobRow.list_plan),
            list_exe: infoJob(jobRow.list_exe),
            list_relMapa: infoJob(jobRow.list_relMapa)
          };
        }) : [];

        const jobsDataWithTotals = jobsData.map(this.calcTotalsForJob);

        function mapAttachment(a) {
          const b64 =
            (a && typeof a.content_base64 === 'string' && a.content_base64) ||
            (a && typeof a.file_signed === 'string' && a.file_signed) ||
            (a && typeof a.file_base64 === 'string' && a.file_base64) || '';
          return {
            id: (a && a.id != null) ? a.id : null,
            id_service_order_job: (a && a.id_service_order_job != null) ? a.id_service_order_job : null,
            id_company: (a && a.id_company != null) ? a.id_company : null,
            file_name: (a && (a.file_name || a.name)) || '',
            file_ext: (a && (a.file_ext || a.ext)) || '',
            mime_type: (a && (a.mime_type || a.mime)) || '',
            size_bytes: Number((a && (a.size_bytes || a.size || 0)) || 0) || 0,
            content_base64: b64
          };
        }

        const signatureRowRaw = Array.isArray(result.signature) ? (result.signature[0] || null) : (result.signature || null);
        const executor = signatureRowRaw && signatureRowRaw.technical_responsible ? String(signatureRowRaw.technical_responsible) : '';
        const cftaCpf = signatureRowRaw && signatureRowRaw.cfta ? String(signatureRowRaw.cfta) : '';
        const executorEmail = signatureRowRaw && signatureRowRaw.technical_responsible_email ? String(signatureRowRaw.technical_responsible_email) : '';
        const sharedClientEmail = signatureRowRaw && signatureRowRaw.client_email ? String(signatureRowRaw.client_email) : '';
        const guidDocument = signatureRowRaw && signatureRowRaw.guid ? String(signatureRowRaw.guid) : '';
        const doc = signatureRowRaw && signatureRowRaw.autentiqueDocument ? signatureRowRaw.autentiqueDocument : null;
        const allParts = Array.isArray(doc && doc.partes) ? doc.partes : [];
        const execEmailLc = (executorEmail || '').toLowerCase();
        const clientEmailLc = (sharedClientEmail || '').toLowerCase();
        const documentParts = allParts.filter(function (p) {
          const em = (p && (p.email || p.mail || '')).toString().toLowerCase();
          if (!execEmailLc && !clientEmailLc) return true;
          return em === execEmailLc || em === clientEmailLc;
        }).slice(0, 2);
        const isSigned = function (p) { return p && typeof p.assinado === 'object' && Object.keys(p.assinado || {}).length > 0; };
        const allSigned = documentParts.length > 0 && documentParts.every(isSigned);
        const fileSigned = signatureRowRaw && signatureRowRaw.file_signed ? String(signatureRowRaw.file_signed) : '';

        const orderAttachmentsRaw = Array.isArray(result.attachments) ? result.attachments : [];
        const orderAttachments = orderAttachmentsRaw.map(mapAttachment);

        const estimateBase64Size = function (b64) {
          if (typeof b64 !== 'string' || b64.length === 0) return 0;
          const clean = b64.replace(/^data:.*;base64,/, '').replace(/\s+/g, '');
          const padding = (clean.match(/=+$/) || [''])[0].length;
          return Math.max(0, Math.floor((clean.length * 3) / 4) - padding);
        };

        const formatDateLabel = function (raw) {
          const s = (raw || '').trim();
          if (!s) return '';
          const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
          if (m) return (m[3] + '/' + m[2] + '/' + m[1]);
          const d = new Date(s);
          if (!isNaN(d.getTime())) {
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yy = d.getFullYear();
            return (dd + '/' + mm + '/' + yy);
          }
          return '';
        };

        const predocAttachments = [];
        let idService;
        for (let i = 0; i < jobsDataWithTotals.length; i++) {
          const job = jobsDataWithTotals[i] || {};
          const b64 = (job.predocument_b64 && String(job.predocument_b64).trim()) || '';
          idService = job.id;
          if (b64 && b64.length > 30) {
            const clean = b64.replace(/^data:.*;base64,/, '');
            const dateLabel = formatDateLabel(job.dateTimeTrabalho);
            predocAttachments.push({
              id: ('predoc_' + dateLabel),
              file_name: (this.props.res.PRE_RELATORIO_MAPA + ' - ' + dateLabel + '.pdf'),
              file_ext: 'pdf',
              mime_type: 'application/pdf',
              size_bytes: estimateBase64Size(clean),
              content_base64: clean,
              readonly: true,
              is_predocument: true
            });
          }
        }

        const signedDocAttachments = [];
        for (let i = 0; i < jobsDataWithTotals.length; i++) {
          const job = jobsDataWithTotals[i] || {};
          const b64 = (job.documentRelMapab64 && String(job.documentRelMapab64).trim()) || '';
          if (b64 && b64.length > 30) {
            const clean = b64.replace(/^data:.*;base64,/, '');
            const dateLabel = formatDateLabel(job.dateTimeTrabalho);
            signedDocAttachments.push({
              id: ('relmapa_signed_' + (job.id || i)),
              file_name: (this.props.res.RELATORIO_MAPA + ' - ' + dateLabel + '.pdf'),
              file_ext: 'pdf',
              mime_type: 'application/pdf',
              size_bytes: estimateBase64Size(clean),
              content_base64: clean,
              readonly: true,
              is_report: true
            });
          }
        }

        let finalAttachments = orderAttachments.slice(0);

        if (signedDocAttachments.length) {
          const existingIds = new Set(finalAttachments.map(function (a) { return String(a.id); }));
          const toAdd = signedDocAttachments.filter(function (a) { return !existingIds.has(String(a.id)); });
          finalAttachments = [].concat(toAdd, finalAttachments);
        } else if (allSigned && fileSigned && fileSigned.length > 30) {
          const clean = fileSigned.replace(/^data:.*;base64,/, '');
          const reportItem = {
            id: idService,
            file_name: (this.props.res.RELATORIO_ASSINADO + '.pdf'),
            file_ext: 'pdf',
            mime_type: 'application/pdf',
            size_bytes: estimateBase64Size(clean),
            content_base64: clean,
            is_report: true,
            readonly: true
          };
          finalAttachments = [reportItem].concat(finalAttachments);
        }

        if (predocAttachments.length) {
          const existingIds2 = new Set(finalAttachments.map(function (a) { return String(a.id); }));
          const toAdd2 = predocAttachments.filter(function (a) { return !existingIds2.has(String(a.id)); });
          finalAttachments = [].concat(toAdd2, finalAttachments);
        }

        const clientName = toStringSafe(result.client).trim();
        const clientEmailFromResult = toStringSafe(result.client_email || result.clientEmail || sharedClientEmail).trim();
        const mergedClients = ensureClientInList(this.state.clients, clientName, clientEmailFromResult);

        const techniciansName = toStringSafe(executor).trim();
        const mergedTechnicians = ensureOptionInList(this.state.technicians, techniciansName, {
          prefix: 'shared_technician_',
          email: executorEmail
        });

        let mergedPilots = Array.isArray(this.state.pilots) ? this.state.pilots.slice(0) : [];
        for (let i = 0; i < jobsDataWithTotals.length; i++) {
          const job = jobsDataWithTotals[i] || {};
          const pilotName = toStringSafe(job.pilot).trim();
          if (pilotName) {
            mergedPilots = ensureOptionInList(mergedPilots, pilotName, {
              prefix: 'shared_pilot_',
              pilotCanac: toStringSafe(job.pilotCanac || ''),
              pilotEmail: toStringSafe(job.pilotEmail || '')
            });
          }
        }

        let mergedPlanes = Array.isArray(this.state.planes) ? this.state.planes.slice(0) : [];
        for (let i = 0; i < jobsDataWithTotals.length; i++) {
          const job = jobsDataWithTotals[i] || {};
          const planeName = toStringSafe(job.plane).trim();
          if (planeName) {
            mergedPlanes = ensureOptionInList(mergedPlanes, planeName, {
              prefix: 'shared_plane_'
            });
          }
        }

        const listExeReturn = [];
        for (let i = 0; i < jobsDataWithTotals.length; i++) {
          const job = jobsDataWithTotals[i];
          if (job && Array.isArray(job.list_exe)) {
            for (let j = 0; j < job.list_exe.length; j++) {
              const exe = job.list_exe[j];
              if (!exe) continue;
              listExeReturn.push({
                id: exe.id,
                id_job: exe.id_job,
                id_job_link: exe.id_job_link,
                guid: exe.guid,
                type: exe.type,
                status_task: exe.status_task,
                progress_task: exe.progress_task,
                id_company: exe.id_company,
                id_company_origin: exe.id_company_origin,
                job_date: exe.job_date || exe.datetime || null,
                plane: exe.plane || '',
                pilot: exe.pilot || '',
                pilot_canac: exe.pilot_canac || '',
                pilot_email: exe.pilot_email || '',
                area: exe.area || exe.area_polygon || null,
                application_type: exe.application_type || null,
                service_type: exe.service_type || null,
                agro_class: exe.agro_class || null,
                application_flow: exe.application_flow || null,
                strip_width: exe.strip_width || null,
                droplet_spectrum: exe.droplet_spectrum || '',
                water_quality: exe.water_quality || '',
                quantity_liters_kilos: exe.quantity_liters_kilos || null,
                equipment: exe.equipment || null,
                risk_area: exe.risk_area || null,
                status: exe.status || exe.status_task || null
              });
            }
          }
        }

        const listPlanReturn = [];
        for (let i = 0; i < jobsDataWithTotals.length; i++) {
          const job = jobsDataWithTotals[i];
          if (job && Array.isArray(job.list_plan)) {
            for (let j = 0; j < job.list_plan.length; j++) {
              const plan = job.list_plan[j];
              if (!plan) continue;
              listPlanReturn.push({
                id: plan.id,
                id_job: plan.id_job,
                id_job_link: plan.id_job_link,
                guid: plan.guid,
                type: plan.type,
                status_task: plan.status_task,
                progress_task: plan.progress_task,
                id_company: plan.id_company,
                id_company_origin: plan.id_company_origin,
                job_date: plan.job_date || plan.datetime || null,
                plane: plan.plane || '',
                pilot: plan.pilot || '',
                pilot_canac: plan.pilot_canac || '',
                pilot_email: plan.pilot_email || '',
                area: plan.area || plan.area_polygon || null,
                application_type: plan.application_type || null,
                service_type: plan.service_type || null,
                agro_class: plan.agro_class || null,
                application_flow: plan.application_flow || null,
                strip_width: plan.strip_width || null,
                droplet_spectrum: plan.droplet_spectrum || '',
                water_quality: plan.water_quality || '',
                quantity_liters_kilos: plan.quantity_liters_kilos || null,
                equipment: plan.equipment || null,
                risk_area: plan.risk_area || null,
                status: plan.status || plan.status_task || null
              });
            }
          }
        }

        const hasPlanningFinished = jobsDataWithTotals.some(function (job) {
          return job && Array.isArray(job.list_plan) && job.list_plan.length > 0;
        });
        const serverPlanningProcessing = !!(result && (result.planning_processing === true || result.planningProcessing === true));
        const isPlanningProcessing = !hasPlanningFinished && (serverPlanningProcessing || this.hasPlanningProcessingStorage(currentId));

        if (!serverPlanningProcessing && !this.state.isPlanningProcessing) {
          this.clearPlanningProcessingStorage(currentId);
        }

        if (hasPlanningFinished) {
          this.clearPlanningProcessingStorage(currentId);
        }

        const serviceOrderProperties = Array.isArray(result.properties) ? result.properties : [];
        const selectedPropertyIds = serviceOrderProperties
          .map(function (item) { return item ? Number(item.id_property || item.idProperty || item.property_id || item.propertyId || item.id) : null; })
          .filter(function (id) { return Number.isInteger(id) && id > 0; });

        const nextState = {
          title: result.title || '',
          serviceOrder: result.order_number || '',
          status: result.status || '',
          responsible: result.responsible || '',
          property: result.property || '',
          selectedPropertyIds: selectedPropertyIds,
          showCustomProperty: !!result.property && selectedPropertyIds.length === 0,
          client: clientName || '',
          contact: result.contact || '',
          address: result.address || '',
          obs: result.observation || '',
          jobsData: jobsDataWithTotals,
          serviceOrderData: result,
          executor: executor,
          executor_cfta_cpf: cftaCpf,
          executorEmail: executorEmail,
          clientEmail: clientEmailFromResult,
          guidDocument: guidDocument,
          documentData: doc,
          fileSigned: fileSigned,
          documentParts: documentParts,
          allSigned: allSigned,
          attachments: finalAttachments,
          companyOriginName: result.company_origin_name || null,
          companySharedName: result.company_shared_name || null,
          companyOriginID: result.id_company_origin || null,
          companyID: result.id_company || null,
          clients: mergedClients,
          technicians: mergedTechnicians,
          pilots: mergedPilots,
          planes: mergedPlanes,
          list_exe_return: listExeReturn,
          list_plan_return: listPlanReturn,
          share_status: result.share_status,
          isPlanningProcessing: isPlanningProcessing
        };

        if (!keepSavingState) {
          nextState.isSavingServiceOrder = false;
        }

        return new Promise((resolve) => {
          this.setState(nextState, () => {
            if (isPlanningProcessing) {
              this.openPlanningProcessingNotification();
            } else {
              this.closePlanningProcessingNotification();
            }
            resolve();
          });
        });
      })
      .catch((error) => {
        if (error && (error.status === 401 || error.status === 403)) {
          this.props.link('/login');
          return;
        } else {
          return new Promise((resolve) => {
            if (keepSavingState) {
              this.setState({ serviceOrder: this.state.serviceOrder }, resolve);
            } else {
              this.setState({ serviceOrder: this.state.serviceOrder, isSavingServiceOrder: false }, resolve);
            }
          });
        }
      });
  };

  readServiceOrder = () => {
    const apiUrl = `${Config.server}/service_order/next_number`;
    const options = {
      method: 'GET',
      headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
    };

    this.setState({ isSavingServiceOrder: true });

    fetch(apiUrl, options)
      .then((res) => { if (res.status !== 200) throw res; return res.json(); })
      .then((result) => {
        const next = (result && result.next != null) ? String(result.next) : String(this.state.serviceOrder || '');
        this.setState({ serviceOrder: next, isSavingServiceOrder: false });
      })
      .catch((error) => {
        if (error && (error.status === 401 || error.status === 403)) {
          this.props.link('/login');
        } else {
          this.setState({ serviceOrder: this.state.serviceOrder, isSavingServiceOrder: false });
        }
      });
  };

  deleteJob = (id) => {
    const apiUrl = `${Config.server}/service_order`;
    const formData = new URLSearchParams();
    let descr = '';

    if (isNaN(id)) {
      formData.append('ids', this.state.selectedJobs);
      descr = this.props.res.ITENS_EXCLUIDOS;
    } else {
      formData.append('ids', id);
      descr = this.props.res.ITEM_EXCLUIDO;
    }

    fetch(apiUrl, {
      method: 'DELETE',
      body: formData,
      headers: { 'Authorization': localStorage.getItem('access-token-jwt') }
    })
      .then((res) => { if (res.status !== 200) throw res; return res.json(); })
      .then(
        (result) => {
          this.setState({ selectedJobs: [] });
          notification.open({
            message: this.props.res.SUCESSO,
            description: descr,
            icon: <MaterialIcon icon="check_circle" className="text-success" />
          });
          if (this.state.id) this.readServiceOrderById();
        },
        (error) => {
          if (error.status === 405) {
            notification.open({ message: this.props.res.PERMISSAO, description: this.props.res.PERMISSAO_MSG, icon: <MaterialIcon icon="error" className="text-danger" /> });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          } else if (error.status === 400) {
            error.json().then((errCode) => {
              notification.open({ message: this.props.res[errCode.code], icon: <MaterialIcon icon="error" className="text-danger" /> });
            });
          } else {
            notification.open({ message: this.props.res.ERRO, description: this.props.res.ERRO_MSG, icon: <MaterialIcon icon="error" className="text-danger" /> });
          }
        }
      );
  };

  downloadRelServiceOrder = async () => {
    if (this.state.isGeneratingReport || this.state.reportGenerated) return;

    if (!this.state.serviceOrderData) {
      notification.open({
        message: this.props.res.ATENCAO,
        description: this.props.res.SEM_DADOS_RELATORIO,
        icon: <MaterialIcon icon="warning" className="text-warning" />
      });
      return;
    }

    this.setState({ isGeneratingReport: true, reportGenerated: true });

    const serviceOrderId = this.state.serviceOrderData.id || this.state.serviceOrderData.id_os;
    const companyId = this.state.serviceOrderData.id_company || this.state.serviceOrderData.company_id;

    const genUrl = Config.server + '/relServiceOrder';

    const bodyRel = Object.assign({}, this.state.serviceOrderData, {
      culture: this.props.res.LINGUA
    });

    const genOptions = {
      method: 'POST',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(bodyRel)
    };

    try {
      const genRes = await fetch(genUrl, genOptions);
      if (genRes.status !== 200) throw genRes;

      const genJson = await genRes.json();
      const pdfData = genJson && genJson.pdfData ? genJson.pdfData : null;

      let blob = new Blob([], { type: 'application/pdf' });
      if (pdfData) {
        try {
          const byteChars = atob(pdfData);
          const byteNumbers = new Array(byteChars.length);
          for (let i = 0; i < byteChars.length; i++) byteNumbers[i] = byteChars.charCodeAt(i);
          const byteArray = new Uint8Array(byteNumbers);
          blob = new Blob([byteArray], { type: 'application/pdf' });
        } catch (e) {
          blob = new Blob([], { type: 'application/pdf' });
        }
      }

      const fileName = 'Ordem-Servico-' + (this.state.serviceOrderData.order_number || '') + '.pdf';
      if (blob && blob.type === 'application/pdf' && blob.size > 0) {
        saveAs(blob, fileName);
      } else {
        notification.open({
          message: this.props.res.ERRO,
          description: this.props.res.ERRO_MSG,
          icon: <MaterialIcon icon="error" className="text-danger" />
        });
        return;
      }

      const clientEmail = (this.state.clientEmail || '').trim();
      const executorEmail = (this.state.executorEmail || '').trim();

      if (clientEmail && executorEmail && pdfData) {
        const signUrl = Config.server + '/relServiceOrderSign';
        const payload = Object.assign({}, this.state.serviceOrderData, {
          pdfData: pdfData,
          signature: Object.assign({}, (this.state.serviceOrderData.signature || {}), {
            client_email: clientEmail,
            technical_responsible_email: executorEmail
          }),
          id_company: companyId,
          service_order_id: serviceOrderId
        });

        const signOptions = {
          method: 'POST',
          headers: {
            'Authorization': localStorage.getItem('access-token-jwt'),
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        };

        try {
          const signRes = await fetch(signUrl, signOptions);
          if (signRes.status === 200) {
            const sj = await signRes.json();
            const guid = sj && sj.guid ? sj.guid : null;

            if (guid && serviceOrderId) {
              const now = new Date();
              try {
                this.updateServiceOrderDocument(serviceOrderId, {
                  id_company: companyId,
                  guid: guid,
                  created_document: now,
                  updated_document: now
                });
              } catch (e) { }
              this.setState({ guidDocument: guid });
            }
          } else if (signRes.status === 400) {
            const sj = await signRes.json().catch(() => ({}));
            notification.open({
              message: this.props.res.ATENCAO,
              description: (sj && sj.message) ? sj.message : this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="warning" className="text-warning" />
            });
          } else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        } catch (e) {
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
      } else if (!clientEmail || !executorEmail) {
        notification.open({
          message: this.props.res.ATENCAO,
          description: this.props.res.INFORMACOES_ASSINATURA,
          icon: <MaterialIcon icon="warning" className="text-warning" />
        });
      }
    } catch (error) {
      if ((this.state.clientEmail || '').trim() === '' || (this.state.executorEmail || '').trim() === '') {
        notification.open({
          message: this.props.res.ERRO,
          description: this.props.res.INFORMACOES_ASSINATURA,
          icon: <MaterialIcon icon="error" className="text-danger" />
        });
      } else if (error && (error.status === 405)) {
        notification.open({
          message: this.props.res.PERMISSAO,
          description: this.props.res.PERMISSAO_MSG,
          icon: <MaterialIcon icon="error" className="text-danger" />
        });
      } else if (error && (error.status === 401 || error.status === 403)) {
        this.props.link('/login');
      } else {
        notification.open({
          message: this.props.res.ERRO,
          description: this.props.res.ERRO_MSG,
          icon: <MaterialIcon icon="error" className="text-danger" />
        });
      }
    } finally {
      this.setState({ isGeneratingReport: false, reportGenerated: false });
    }
  };

  updateServiceOrderDocument = (id_os, payload) => {
    const apiUrl = Config.server + '/service_order/document/' + id_os;
    const options = {
      method: 'PUT',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    };

    return fetch(apiUrl, options)
      .then((res) => { if (res.status !== 200) throw res; return res.json(); })
      .then((json) => json)
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        } else {
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
        throw error;
      });
  };

  handleOpenModal = () => {
    this.readServiceOrderById();
    this.setState({ openModal: true });
  };

  handleCloseModal = () => {
    this.setState({ openModal: false });
  };

  getStatusDetails = (part) => {
    const has = (o) => o && typeof o === 'object' && Object.keys(o).length > 0;

    const sentAt = part?.mail?.delivered || part?.mail?.sent || part?.created || null;
    const viewedAt = has(part?.visualizado) ? (part.visualizado.created || part.visualizado.data) : null;
    const signedAt = has(part?.assinado) ? (part.assinado.created || part.assinado.data) : null;
    const refusedAt = has(part?.rejeitado) ? (part.rejeitado.created || part.rejeitado.data) : (part?.mail?.refused || null);

    let etapa = 'Pendente';
    let icon = <HourglassEmptyIcon />;
    let date = null;

    if (sentAt) { etapa = 'Enviado'; icon = <MailOutlineIcon />; date = sentAt; }
    if (viewedAt) { etapa = 'Visualizado'; icon = <VisibilityIcon style={{ color: '#1976d2' }} />; date = viewedAt; }
    if (signedAt) { etapa = 'Assinado'; icon = <CheckCircleIcon style={{ color: '#2e7d32' }} />; date = signedAt; }
    if (refusedAt) { etapa = 'Rejeitado'; icon = <CancelIcon style={{ color: '#c62828' }} />; date = refusedAt; }

    return { icon, etapa, date };
  };

  getNameFromEmail = (email) => {
    if (!email) return '';
    const at = String(email).indexOf('@');
    return at > 0 ? String(email).slice(0, at) : String(email);
  };

  getFunctionFromEmail = (email) => {
    const e = (email || '').toLowerCase();
    if (e && this.state.executorEmail && e === this.state.executorEmail.toLowerCase()) return 'Responsável Técnico';
    if (e && this.state.clientEmail && e === this.state.clientEmail.toLowerCase()) return 'Cliente';
    return '-';
  };

  openDeleteConfirm = () => this.setState({ docDeleteConfirmOpen: true });
  closeDeleteConfirm = () => this.setState({ docDeleteConfirmOpen: false });

  handleDeleteSignature = () => {
    const id_os = this.state.id || this.state.serviceOrderData?.id;
    this.updateServiceOrderDocument(id_os, { delete_document: true })
      .then(() => {
        this.closeDeleteConfirm();
        this.readServiceOrderById();
        this.handleCloseModal();
      })
      .catch(() => { });
  };

  cleanBase64 = function (b64) {
    return String(b64 || '')
      .replace(/^data:.*;base64,/, '')
      .replace(/[\r\n]+/g, '')
      .replace(/\s+/g, '');
  };

  extractB64 = function (val) {
    if (!val) return '';
    if (typeof val === 'string') return val;
    if (typeof val === 'object') {
      if (typeof val.file_signed === 'string') return val.file_signed;
      if (typeof val.base64 === 'string') return val.base64;
      if (typeof val.data === 'string') return val.data;
    }
    return '';
  };

  downloadReportSigned = function (arg, filename = 'relatorio-assinado.pdf', openInNewTab = false) {
    let url = null;

    try {
      var fromParam = this.extractB64(arg);
      var fromState =
        this.extractB64(this.state && this.state.fileSigned) ||
        this.extractB64(this.state && this.state.signature);

      var src = fromParam || fromState;

      if (typeof arg === 'object' && arg && arg.nativeEvent)

        if (!src) { return; }

      var b64Raw = this.cleanBase64(src);

      if (!b64Raw) { return; }
      var base64OkChars = /^[A-Za-z0-9+/=]+$/;
      var onlyOk = base64OkChars.test(b64Raw);

      var mod4 = b64Raw.length % 4;
      var b64 = mod4 ? b64Raw + '='.repeat(4 - mod4) : b64Raw;

      var byteChars;
      try {
        byteChars = atob(b64);
      } catch (e) {
        return;
      }

      var sliceSize = 64 * 1024;
      var slices = Math.ceil(byteChars.length / sliceSize);
      var parts = new Array(slices);

      for (var i = 0; i < slices; i++) {
        var begin = i * sliceSize;
        var end = Math.min(begin + sliceSize, byteChars.length);
        var chunk = byteChars.slice(begin, end);
        var bytes = new Uint8Array(chunk.length);
        for (var j = 0; j < chunk.length; j++) bytes[j] = chunk.charCodeAt(j);
        parts[i] = bytes;
      }

      var blob = new Blob(parts, { type: 'application/pdf' });
      url = URL.createObjectURL(blob);
      if (openInNewTab) {
        window.open(url, '_blank');
      } else {
        var a = document.createElement('a');
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    } catch (e) {
    } finally {
      if (url) { URL.revokeObjectURL(url); }
    }
  };

  loadCultures = () => {
    const apiUrl = Config.server + '/domain/CULTURA';

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt'),
      }
    }

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .then(
        (result) => {
          this.setState({
            cultureData: result
          });
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          }
          else {
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  }

  attachmentsFormatSize = (bytes) => {
    const byteCount = Number(bytes || 0);
    if (!isFinite(byteCount) || byteCount <= 0) return '-';
    if (byteCount < 1024) return `${byteCount}b`;
    if (byteCount < 1048576) return `${Math.round(byteCount / 1024)}kb`;
    return `${(byteCount / 1048576).toFixed(2)}mb`;
  };

  attachmentsOpenPicker = () => {
    const inputElement = this.attachmentInputRef && this.attachmentInputRef.current;
    if (inputElement) inputElement.click();
  };

  getFileExtension = (fileName) => {
    if (!fileName) return '';
    const dotIndex = fileName.lastIndexOf('.');
    return dotIndex >= 0 ? fileName.slice(dotIndex + 1).toLowerCase() : '';
  };

  guessMimeType = (file) => {
    if (file?.type) return file.type;
    const ext = this.getFileExtension(file?.name);
    if (ext === 'kml') return 'application/vnd.google-earth.kml+xml';
    if (ext === 'kmz') return 'application/vnd.google-earth.kmz';
    if (ext === 'shp') return 'application/octet-stream';
    if (ext === 'zip') return 'application/zip';
    return 'application/octet-stream';
  };

  addFilesAsAttachments = (files) => {
    const { res } = this.props;

    const attachmentMaxBytes = 10 * 1024 * 1024;
    const fileArray = Array.isArray(files) ? files : [];
    if (!fileArray.length) return;
    const notifier = (this.props.notification) || (typeof notification !== 'undefined' ? notification : null);
    const buildTempId = (f) => `tmp_${f.name}-${f.size}-${f.lastModified}-${Math.random().toString(36).slice(2)}`;

    const oversized = [];
    const accepted = [];

    for (let i = 0; i < fileArray.length; i++) {
      const file = fileArray[i];
      const size = Number(file && file.size);
      if (!isFinite(size) || size <= 0) continue;

      if (size > attachmentMaxBytes) {
        oversized.push({ name: file.name, size });
        continue;
      }

      const file_ext = this.getFileExtension(file.name);
      const mime_type = this.guessMimeType(file);
      const url = URL.createObjectURL(file);

      accepted.push({
        id: buildTempId(file),
        fileName: file.name,
        file_ext,
        mime_type,
        size,
        size_bytes: size,
        file,
        url
      });
    }

    if (oversized.length && notifier && notifier.open) {
      const list = oversized
        .map(o => `${o.name} (${this.attachmentsFormatSize(o.size)})`)
        .join(', ');
      notifier.open({
        message: (res.ERRO),
        description:
          `${list} ${res.TAMANHO_LIMITE_ANEXO}`
      });
    }

    if (!accepted.length) return;

    this.setState((prev) => {
      const current = Array.isArray(prev.attachments) ? prev.attachments : [];
      const existing = new Set(current.map((a) => `${a.fileName || a.file_name}|${a.size || a.size_bytes}`));
      const deduped = accepted.filter((a) => !existing.has(`${a.fileName}|${a.size}`));
      return { attachments: [...deduped, ...current] };
    });
  };

  attachmentsOnInputChange = (event) => {
    const selectedFiles = Array.from(event?.target?.files || []);
    if (!selectedFiles.length) return;
    this.addFilesAsAttachments(selectedFiles);
    if (event?.target) event.target.value = '';
  };

  attachmentsViewItem = (target) => {
    const { res } = this.props;

    const list = Array.isArray(this.state.attachments) ? this.state.attachments : [];
    const item = (target && typeof target === 'object')
      ? target
      : (Number.isInteger(target) ? (list[target] || null) : list.find((x) => x && String(x.id) === String(target)));

    if (!item) {
      const notifier = (this.props.notification.notification) || (typeof notification !== 'undefined' ? notification : null);
      if (notifier?.open) notifier.open({ message: (res.ERRO), description: (res.ARQUIVO_NAO_ENCONTRADO) });
      return;
    }

    const getExt = (name) => {
      if (!name) return '';
      const i = name.lastIndexOf('.');
      return i >= 0 ? name.slice(i + 1).toLowerCase() : '';
    };

    const inferMime = (ext) => {
      if (ext === 'pdf') return 'application/pdf';
      if (ext === 'png') return 'image/png';
      if (ext === 'jpg' || ext === 'jpeg') return 'image/jpeg';
      if (ext === 'kml') return 'application/vnd.google-earth.kml+xml';
      if (ext === 'kmz') return 'application/vnd.google-earth.kmz';
      return 'application/octet-stream';
    };

    const ensureExt = (name, ext) => {
      const n = String(name || 'arquivo').trim() || 'arquivo';
      const has = n.toLowerCase().endsWith(`.${ext}`);
      return has ? n : `${n}.${ext}`;
    };

    const triggerDownload = (href, filename) => {
      const a = document.createElement('a');
      a.href = href;
      a.download = filename || 'download';
      document.body.appendChild(a);
      a.click();
      a.remove();
    };

    const toBlobFromBase64 = (b64, mime) => {
      let s = b64.replace(/\s+/g, '').replace(/-/g, '+').replace(/_/g, '/');
      const pad = s.length % 4;
      if (pad) s += '='.repeat(4 - pad);
      const binary = atob(s);
      const bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
      return new Blob([bytes], { type: mime || 'application/octet-stream' });
    };

    const nameProp = item.fileName || item.file_name || 'arquivo';
    const extProp = (item.file_ext || getExt(nameProp)).toLowerCase();
    const ext = extProp || 'bin';
    const mimeType = item.mime_type || inferMime(ext);

    const isPreviewable = ext === 'pdf' || ext === 'png' || ext === 'jpg' || ext === 'jpeg';
    const isKmlKmz = ext === 'kml' || ext === 'kmz';

    const base64 =
      (typeof item.content_base64 === 'string' && item.content_base64) ||
      (typeof item.file_base64 === 'string' && item.file_base64) ||
      (typeof item.file_signed === 'string' && item.file_signed) ||
      '';

    if (isKmlKmz) {
      const fileName = ensureExt(nameProp, ext);
      if (item.url) {
        triggerDownload(item.url, fileName);
        return;
      }
      if (item.file instanceof File) {
        const url = URL.createObjectURL(item.file);
        triggerDownload(url, fileName);
        setTimeout(() => { try { URL.revokeObjectURL(url); } catch (_) { } }, 60000);
        return;
      }
      if (typeof base64 === 'string' && base64.length > 30) {
        if (base64.startsWith('data:') && base64.includes(';base64,')) {
          triggerDownload(base64, fileName);
          return;
        }
        const blob = toBlobFromBase64(base64, mimeType || inferMime(ext));
        const url = URL.createObjectURL(blob);
        triggerDownload(url, fileName);
        setTimeout(() => { try { URL.revokeObjectURL(url); } catch (_) { } }, 60000);
        return;
      }
      const notifier = (this.props && this.props.notification) || (typeof notification !== 'undefined' ? notification : null);
      if (notifier?.open) notifier.open({ message: (res.ERRO), description: (res.ARQUIVO_NAO_ENCONTRADO) });
      return;
    }

    if (item.url) {
      window.open(item.url, '_blank');
      return;
    }

    if (item.file instanceof File) {
      const url = URL.createObjectURL(item.file);
      window.open(url, '_blank');
      const index = list.indexOf(item);
      if (index >= 0) {
        const updated = list.slice();
        updated[index] = { ...item, url };
        this.setState({ attachments: updated });
      }
      setTimeout(() => { try { URL.revokeObjectURL(url); } catch (_) { } }, 60000);
      return;
    }

    if (typeof base64 === 'string' && base64.length > 30) {
      if (base64.startsWith('data:') && base64.includes(';base64,')) {
        window.open(base64, '_blank');
        return;
      }
      const blob = toBlobFromBase64(base64, mimeType);
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
      setTimeout(() => { try { URL.revokeObjectURL(url); } catch (_) { } }, 60000);
      return;
    }

    const notifier = (this.props.notification.notification) || (typeof notification !== 'undefined' ? notification : null);
    if (notifier?.open) notifier.open({ message: (res.ERRO), description: (res.ARQUIVO_NAO_ENCONTRADO) });
  };

  captureAreaFilesToAttachments = (eventOrFiles) => {
    const files = Array.isArray(eventOrFiles)
      ? eventOrFiles
      : Array.from(eventOrFiles?.target?.files || []);
    if (!files.length) return;
    this.addFilesAsAttachments(files);
  };

  attachmentsRemoveItem = (target) => {
    const list = Array.isArray(this.state.attachments) ? this.state.attachments : [];
    let index = -1;
    let item = null;

    if (Number.isInteger(target)) {
      index = target;
      item = list[index] || null;
    } else if (target && typeof target === 'object') {
      index = list.indexOf(target);
      item = index >= 0 ? target : null;
    } else {
      index = list.findIndex((x) => String(x?.id) === String(target));
      item = index >= 0 ? list[index] : null;
    }

    if (!item) return;

    if (item.is_report || item.readonly) return;

    const objectUrl = item.url || null;
    const remaining = list.filter((_, i) => i !== index);
    const prevRemoveIds = Array.isArray(this.state.attachmentsRemoveIds) ? this.state.attachmentsRemoveIds : [];
    const shouldMarkDeletion = Number.isInteger(item.id) && item.id > 0;
    const nextRemoveIds = shouldMarkDeletion ? Array.from(new Set([...prevRemoveIds, Number(item.id)])) : prevRemoveIds;

    if (objectUrl) { try { URL.revokeObjectURL(objectUrl); } catch (_) { } }

    this.setState({ attachments: remaining, attachmentsRemoveIds: nextRemoveIds });
  };

  readJobAreaType = (idJob, type) => {
    const apiUrl = `${Config.server}/job_area/${idJob}/${type}`;
    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    return fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        else return res.json();
      })
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          if (typeof this.props.link === 'function') this.props.link('/login');
        } else {
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
        throw error;
      });
  };

  loadAreasForJob = async (idJob) => {
    if (idJob == null) return;
    if (this.state.jobAreasLoading?.[idJob]) return;
    if (this.state.jobAreas?.[idJob]?.loaded) return;

    this.setState(prev => ({ jobAreasLoading: { ...(prev.jobAreasLoading || {}), [idJob]: true } }));
    if (typeof this.showPro === 'function') this.showPro(true);

    const asArray = (v) => (Array.isArray(v) ? v : []);

    try {
      const [planejamento, execucao, area] = await Promise.all([
        this.readJobAreaType(idJob, 'planejamento'),
        this.readJobAreaType(idJob, 'execucao'),
        // this.readJobAreaType(idJob, 'area'),
      ]);

      this.setState(prev => ({
        jobAreas: {
          ...(prev.jobAreas || {}),
          [idJob]: {
            planejamento: asArray(planejamento),
            execucao: asArray(execucao),
            // area: asArray(area),
            loaded: true,
          }
        }
      }));
    } catch (error) {
    } finally {
      this.setState(prev => ({ jobAreasLoading: { ...(prev.jobAreasLoading || {}), [idJob]: false } }));
      if (typeof this.showPro === 'function') this.showPro(false);
    }
  };

  toggleExpandRow = (rowKey, trab) => {
    this.setState(prev => {
      const set = new Set(prev.expandedRows || []);
      const isOpen = set.has(rowKey);

      if (isOpen) {
        set.delete(rowKey);
      } else {
        set.add(rowKey);

        const toNum = (v) => {
          const n = Number(v);
          return Number.isFinite(n) && n > 0 ? n : null;
        };

        const idJob =
          toNum(trab?.id_job) ??
          toNum(trab?.id_job_link) ??
          toNum(trab?.list_exe?.[0]?.id_job) ??
          toNum(trab?.list_plan?.[0]?.id_job) ??
          null;

        if (idJob && typeof this.loadAreasForJob === 'function') {
          Promise.resolve()
            .then(() => this.loadAreasForJob(idJob))
            .catch(() => { });
        }
      }

      return { expandedRows: Array.from(set) };
    });
  };

  getJobAreasById = (idJob) => {
    return this.state.jobAreas?.[idJob] || { planejamento: [], execucao: [], loaded: false };
    // return this.state.jobAreas?.[idJob] || { planejamento: [], execucao: [], area: [], loaded: false };
  };

  isJobAreasLoading = (idJob) => {
    return !!this.state.jobAreasLoading?.[idJob];
  };

  getAreaTab = (idJob) => {
    return (this.state.areaTabByJob && this.state.areaTabByJob[idJob]) || 'areaOS';
  };

  setAreaTab = (idJob, tab) => {
    this.setState(prev => ({
      areaTabByJob: { ...(prev.areaTabByJob || {}), [idJob]: tab }
    }), () => {
      if (tab !== 'areaOS') this.loadAreasForJob(idJob);
    });
  };

  recalcProductTotalsFromArea = (rawArea) => {
    const job = this.getTrabalho && this.getTrabalho();
    const areaNum = this.parseNum(rawArea != null ? rawArea : (job?.sizeArea));
    const list = Array.isArray(job?.list_prod) ? [...job.list_prod] : [];
    for (let i = 0; i < list.length; i++) {
      const doseNum = this.parseNum(list[i]?.dosage);
      const totalNum = areaNum * doseNum;
      list[i] = { ...list[i], total: Number.isFinite(totalNum) ? totalNum : 0 };
    }
    this.setTrabalhoValor('list_prod', list);
    this.setState({ isRel: false });
  };

  setProductDosage = (index, value) => {
    const job = this.getTrabalho && this.getTrabalho();
    const list = Array.isArray(job?.list_prod) ? [...job.list_prod] : [];
    if (!list[index]) return;

    const areaNum = this.parseNum(job?.sizeArea);
    const doseNum = this.parseNum(value);
    const totalNum = areaNum * doseNum;

    list[index] = {
      ...list[index],
      dosage: value,
      total: Number.isFinite(totalNum) ? totalNum : 0
    };

    this.setTrabalhoValor('list_prod', list);
    this.setState({ isRel: false });
  };

  calcTotalsForJob = (job) => {
    const area = this.parseNum(job.sizeArea);
    const prods = Array.isArray(job.list_prod) ? [...job.list_prod] : [];
    for (let i = 0; i < prods.length; i++) {
      const d = this.parseNum(prods[i].dosage);
      const t = area * d;
      prods[i] = { ...prods[i], total: Number.isFinite(t) ? t : 0 };
    }
    return { ...job, list_prod: prods };
  };

  toNumber = (value) => {
    if (value === null || value === undefined) return 0;
    let s = String(value).trim();
    if (!s) return 0;

    s = s.replace(/[^\d.,\-]/g, '');

    let neg = false;
    if (s.startsWith('-')) { neg = true; s = s.slice(1); }

    const seps = (s.match(/[.,]/g) || []);
    if (seps.length > 1) {
      const lastDot = s.lastIndexOf('.');
      const lastComma = s.lastIndexOf(',');
      const lastSep = lastDot > lastComma ? '.' : ',';
      s = s.replace(/[.,]/g, (m, idx) => (idx === (lastSep === '.' ? lastDot : lastComma) ? '.' : ''));
    } else if (seps.length === 1) {
      const sep = seps[0];
      const idx = s.indexOf(sep);
      const decimals = s.length - idx - 1;
      const digitsBefore = s.slice(0, idx).replace(/[^\d]/g, '').length;
      if (decimals === 3 && digitsBefore > 3) {
        s = s.replace(sep, '');
      } else {
        s = s.replace(sep, '.');
      }
    }

    const n = Number((neg ? '-' : '') + s);
    return Number.isFinite(n) ? n : 0;
  };

  parseNum = (v) => {
    if (v === null || v === undefined) return 0;
    let s = String(v).trim();
    if (!s) return 0;

    s = s.replace(/[^\d.,\-]/g, '');

    let neg = false;
    if (s.startsWith('-')) { neg = true; s = s.slice(1); }

    const lastDot = s.lastIndexOf('.');
    const lastComma = s.lastIndexOf(',');
    const decPos = Math.max(lastDot, lastComma);

    if (decPos >= 0) {
      const intPart = s.slice(0, decPos).replace(/[^\d]/g, '');
      const fracPart = s.slice(decPos + 1).replace(/[^\d]/g, '');
      s = intPart + (fracPart ? '.' + fracPart : '');
    } else {
      s = s.replace(/[^\d]/g, '');
    }

    const n = Number((neg ? '-' : '') + s);
    return Number.isFinite(n) ? n : 0;
  };

  formatBR = (n, fd = 2) =>
  (Number.isFinite(Number(n)) ? new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: fd, maximumFractionDigits: fd
  }).format(Number(n)) : '');


  toDecimal = (value) => {
    if (value === undefined || value === null || String(value).trim() === '') return 0;
    let v = String(value).trim();
    v = v.replace(/[^\d,.\-]/g, '');
    v = v.replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(',', '.');
    const n = Number(v);
    return isNaN(n) ? 0 : n;
  };

  setProductUnit = (index, value) => {
    const job = this.getTrabalho && this.getTrabalho();
    const list = Array.isArray(job?.list_prod) ? [...job.list_prod] : [];
    if (!list[index]) return;
    const unit = value ? String(value).toLowerCase() : '';
    list[index] = { ...list[index], unit };
    this.setTrabalhoValor('list_prod', list);
    this.setState({ isRel: false });
  };

  updateJobArea = (jobIndex, rawArea) => {
    this.setState((prev) => {
      const jobs = [...(prev.jobsData || [])];
      if (!jobs[jobIndex]) return null;
      const job = { ...jobs[jobIndex], sizeArea: rawArea };
      const updated = this.calcTotalsForJob(job);
      jobs[jobIndex] = updated;
      return { jobsData: jobs };
    });
  };

  setAreaHa = (value) => {
    this.setTrabalhoValor('sizeArea', value);
    this.recalcProductTotalsFromArea(value);
  };

  openNewProductModal = () => {
    this.setState({ newProductModalOpen: true, newProductName: '' });
  };

  closeNewProductModal = () => {
    this.setState({ newProductModalOpen: false, newProductName: '', newProductSaving: false });
  };

  onNewProductNameChange = (e) => {
    this.setState({ newProductName: (e && e.target && e.target.value ? e.target.value : '').slice(0, 120) });
  };

  saveNewProductCustom = () => {
    const name = (this.state.newProductName || '').trim();
    if (!name) return;
    if (this.state.newProductSaving) return;

    this.setState({ newProductSaving: true });

    const apiUrl = (Config.server + '/product_custom');
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('access-token-jwt')
      },
      body: JSON.stringify({ name: name })
    };

    fetch(apiUrl, options)
      .then(function (res) { if (res.status !== 200) throw res; return res.json(); })
      .then((result) => {
        const serverId = Number(result && result.id);
        if (Number.isFinite(serverId) && serverId > 0) {
          const trabalho = this.getTrabalho ? this.getTrabalho() : {};
          const selected = Array.isArray(trabalho && trabalho.list_prod) ? trabalho.list_prod.slice() : [];

          const cleaned = [];
          const seenCustom = new Set();

          for (let i = 0; i < selected.length; i++) {
            const p = selected[i];
            if (!p) continue;

            const src = String((p.source || p.src || '')).toLowerCase();
            const hintedCustom = (p.is_custom === true || p.is_custom === 1) || (src === 'custom');

            const idcProp = (p.id_product_custom != null ? p.id_product_custom : (p.idProductCustom != null ? p.idProductCustom : null));
            let idc = Number(idcProp);

            if (!Number.isFinite(idc) || idc <= 0) {
              if (hintedCustom) continue;
              cleaned.push(p);
              continue;
            }

            if (hintedCustom) {
              const key = 'c:' + idc;
              if (idc === serverId) {
                if (seenCustom.has(key)) continue;
                seenCustom.add(key);
                cleaned.push(p);
              } else {
                if (seenCustom.has(key)) continue;
                seenCustom.add(key);
                cleaned.push(p);
              }
            } else {
              cleaned.push(p);
            }
          }

          if (!seenCustom.has('c:' + serverId)) {
            cleaned.push({
              uid: ('custom:' + serverId),
              source: 'custom',
              is_custom: true,
              id_product_custom: serverId,
              idProductCustom: serverId,
              name: name,
              dosage: '',
              unit: '',
              total: 0
            });
          }

          this.setTrabalhoValor('list_prod', cleaned);
        }

        this.getProdCustom();
        this.setState({ newProductSaving: false, newProductModalOpen: false, newProductName: '' });
      })
      .catch((error) => {
        if (error && (error.status === 401 || error.status === 403)) {
          this.props.link('/login');
        } else if (error && error.status === 400) {
          error.json().then((errCode) => {
            notification.open({
              message: this.props.res[errCode.code],
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          });
        } else {
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
        this.setState({ newProductSaving: false });
      });
  };

  getProdCustom = () => {
    const apiUrl = (Config.server + '/product_custom');
    const options = { method: 'GET', headers: { 'Authorization': localStorage.getItem('access-token-jwt') } };

    fetch(apiUrl, options)
      .then(function (res) { if (res.status !== 200) throw res; return res.json(); })
      .then((result) => {
        if (!Array.isArray(result) || !result.length) return;

        const atual = Array.isArray(this.state.list_all_prod) ? this.state.list_all_prod : [];

        const normalizarItem = function (item, indexBase) {
          const id = Number(item.id);
          return {
            id: id,
            name: item.name,
            index: indexBase,
            source: 'custom',
            is_custom: true,
            uid: ('custom:' + id)
          };
        };

        const incoming = result.map(function (it, k) { return normalizarItem(it, (atual.length + k)); });

        const map = new Map(
          atual.map(function (p) {
            const baseUid = (p.uid ? String(p.uid) : (String(p.source || '').toLowerCase() === 'custom' ? ('custom:' + (p.id != null ? p.id : p.id_product_custom)) : (p.id || p.code || p.name)));
            return [String(baseUid).toLowerCase(), p];
          })
        );

        for (let i = 0; i < incoming.length; i++) {
          const novo = incoming[i];
          const key = String(novo.uid).toLowerCase();
          if (map.has(key)) {
            const merged = Object.assign({}, map.get(key), novo);
            map.set(key, merged);
          } else {
            map.set(key, novo);
          }
        }

        this.setState({ list_all_prod: Array.from(map.values()) });
      })
      .catch((error) => {
        if (error && error.status === 401) this.props.link('/login');
        else {
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
      });
  };

  toNum = (v) => {
    if (v === null || v === undefined || v === '') return 0;
    let s = String(v).replace(/[^\d,.\-]/g, '');
    s = s.replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(',', '.');
    const n = Number(s);
    return isNaN(n) ? 0 : n;
  };

  getAllProducts = () => (Array.isArray(this.state.list_all_prod) ? this.state.list_all_prod : []);

  getSelectedProducts = () => {
    const list = this.getTrabalho().list_prod;
    return Array.isArray(list) ? list : [];
  };

  setSelectedProducts = (arr) => {
    this.setTrabalhoValor('list_prod', Array.isArray(arr) ? arr.slice() : []);
    this.setState({ isRel: false });
  };

  productTotal = (dosage, areaHa) => {
    const d = this.toNum(dosage);
    const a = this.toNum(areaHa);
    const t = d * a;
    return Number.isFinite(t) ? t : 0;
  };

  onProductFilterChange = (e) => {
    this.setState({ productFilter: (e && e.target && e.target.value) || '', productPage: 1 });
  };

  onProductPage = (dir, totalPages) => {
    const page = Math.max(1, Number(this.state.productPage || 1));
    const next = Math.max(1, Math.min(totalPages, page + dir));
    this.setState({ productPage: next });
  };

  toggleProductSelect = (product) => {
    const sel = this.getSelectedProducts();
    const uid = product.uid || `${product.source === 'custom' ? 'custom' : 'master'}:${product.id}`;
    const hitIdx = sel.findIndex((p) => (p.uid ? p.uid === uid : (String(p.id) === String(product.id))));

    if (hitIdx >= 0) {
      const next = sel.slice();
      next.splice(hitIdx, 1);
      this.setSelectedProducts(next);
      return;
    }

    const isCustom = (product.source === 'custom') || product.is_custom === true;
    const payload = {
      uid,
      source: isCustom ? 'custom' : 'master',
      ...(isCustom ? { idProductCustom: Number(product.id) } : { idProduct: Number(product.id) }),
      id: Number(product.id),
      name: product.name,
      description: product.description,
      unit: '',
      dosage: '',
      total: 0,
      toxicClass: '',
      applicationRate: '',
      from_custom: !!isCustom
    };

    this.setSelectedProducts([...sel, payload]);
  };

  setProductUnit = (idx, unit) => {
    const list = this.getSelectedProducts();
    if (!list[idx]) return;
    const next = list.slice();
    next[idx] = { ...next[idx], unit: unit || '' };
    this.setSelectedProducts(next);
  };

  setProductDosage = (idx, dosage) => {
    const list = this.getSelectedProducts();
    if (!list[idx]) return;
    const areaHa = this.toNum(this.getTrabalho().sizeArea);
    const total = this.productTotal(dosage, areaHa);
    const next = list.slice();
    next[idx] = { ...next[idx], dosage, total };
    this.setSelectedProducts(next);
  };

  setProductField = (uidOrId, field, value) => {
    const list = this.getSelectedProducts();
    const idx = list.findIndex((p) => String(p.uid) === String(uidOrId) || String(p.id) === String(uidOrId));
    if (idx < 0) return;
    if (field === 'dosage') return this.setProductDosage(idx, value);
    const next = list.slice();
    next[idx] = { ...next[idx], [field]: value };
    this.setSelectedProducts(next);
  };

  onAreaChangeWithTotals = (e) => {
    const val = e && e.target ? e.target.value : '';
    this.setAreaHa(val);
    this.selectedProductsTotals();
  };

  selectedProductsTotals = () => {
    const areaHa = this.toNum(this.getTrabalho().sizeArea);
    const sel = this.getSelectedProducts().map((p) => ({
      ...p,
      total: this.productTotal(p && p.dosage, areaHa),
    }));
    this.setSelectedProducts(sel);
  };

  openEditForm = () => {
    this.setState({ editForm: true });
  };

  openAttention = (descKey) => {
    const { res } = this.props;
    notification.open({
      message: res.ATENCAO,
      description: res[descKey],
      icon: <MaterialIcon icon="warning" className="text-warning" />
    });
  };

  alertReadOnly = () => this.openAttention('SELECIONAR_EDICAO');
  alertSaveFirst = () => this.openAttention('SALVAR_ALTERACOES');

  alert = (key) => this.openAttention(key);

  updateShareCompanyList = () => {
    const apiUrl = Config.server + '/company_link/client';

    this.setState({ loadingShareList: true });

    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    fetch(apiUrl, options)
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            dataShare: Array.isArray(result) ? result : [],
            loadingShareList: false
          });
        },
        (error) => {
          this.setState({ loadingShareList: false });

          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          } else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }
        }
      );
  };

  openShareModal = () => {
    const osId = this.state.id;
    if (!osId) return;

    this.setState(
      {
        shareModalOpen: true,
        selectedShareCompanyId: null,
        dataShare: []
      },
      () => {
        this.updateShareCompanyList();
      }
    );
  };

  handleSelectShareCompany = (event) => {
    const selectedShareCompanyId = Number(event.target.value) || null;

    this.setState({
      selectedShareCompanyId: selectedShareCompanyId
    });
  };

  sendShareServiceOrder = async () => {
    const osId = this.state.id;
    const { selectedShareCompanyId } = this.state;
    const currentJobPlaneData = this.getCurrentJobPlaneDataForShare();

    if (!osId) {
      return notification.open({
        message: this.props.res.ERRO,
        description: this.props.res.ARQUIVO_INVALIDO,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
    }

    if (!selectedShareCompanyId) {
      return notification.open({
        message: this.props.res.ATENCAO,
        description: this.props.res.SELECIONAR_COMPARTILHAMENTO_OS,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
    }

    this.setState({ sendingShare: true });

    try {
      await new Promise((resolve) =>
        this.setState({ status: 'Aguardando Aprovação' }, resolve)
      );

      if (typeof this.salvarTrabalho === 'function') {
        await this.salvarTrabalho({ silent: true, skipReload: true });
      }

      const payload = {
        id_company_linked: selectedShareCompanyId,
        id_plane: currentJobPlaneData.planeId || null,
        plane_name: currentJobPlaneData.planeName || ''
      };

      const apiUrl = `${Config.server}/service_order/share/${osId}`;

      const options = {
        method: 'POST',
        headers: {
          'Authorization': localStorage.getItem('access-token-jwt'),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      };

      const res = await fetch(apiUrl, options);
      const result = await res.json();

      this.setState({
        sendingShare: false,
        shareModalOpen: false
      });

      if (result && result.error) {
        return notification.open({
          message: this.props.res.ERRO,
          description: result.message || this.props.res.ERRO_MSG,
          icon: <MaterialIcon icon="error" className="text-danger" />
        });
      }

      this.setState({
        share_status: 'compartilhado',
        status: 'Aguardando Aprovação'
      });

      if (typeof this.readServiceOrderById === 'function') {
        this.readServiceOrderById();
      }

      notification.open({
        message: this.props.res.SUCESSO,
        description: this.props.res.ORDEM_SERVICO_COMPARTILHADA,
        icon: <MaterialIcon icon="check_circle" className="text-success" />
      });
    } catch (error) {
      this.setState({ sendingShare: false });

      if (error && (error.status === 401 || error.status === 403)) {
        this.props.link('/login');
      } else {
        console.log(error);
        notification.open({
          message: this.props.res.ERRO,
          description: this.props.res.ERRO_MSG,
          icon: <MaterialIcon icon="error" className="text-danger" />
        });
      }
    }
  };

  sendReturnServiceOrder = async () => {
    const osId = this.state.id;
    const originCompanyId = this.state.companyOriginID;

    if (!osId) {
      return notification.open({
        message: this.props.res.ERRO,
        description: this.props.res.ARQUIVO_INVALIDO,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
    }

    if (!originCompanyId) {
      return notification.open({
        message: this.props.res.ERRO,
        icon: <MaterialIcon icon="error" className="text-danger" />
      });
    }

    this.setState({ sendingReturn: true });

    try {
      await new Promise((resolve) =>
        this.setState({ status: 'Aguardando Validação' }, resolve)
      );

      await this.salvarTrabalho({
        silent: true,
        skipServiceOrderPdfNotify: true,
        skipServiceOrderAttachmentsNotify: true
      });

      const apiUrl = `${Config.server}/service_order/return/${osId}`;

      const options = {
        method: 'POST',
        headers: {
          'Authorization': localStorage.getItem('access-token-jwt'),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id_company_linked: originCompanyId,
          list_exe: this.state.list_exe_return || [],
          list_plan: this.state.list_plan_return || []
        })
      };

      const res = await fetch(apiUrl, options);
      const result = await res.json();

      this.setState({ sendingReturn: false });

      if (result && result.error) {
        return notification.open({
          message: this.props.res.ERRO,
          description: this.props.res.ERRO_MSG,
          icon: <MaterialIcon icon="error" className="text-danger" />
        });
      }

      this.setState({
        share_status: 'retornado',
        status: 'Aguardando Validação',
        id_company_active: originCompanyId
      });

      notification.open({
        message: this.props.res.SUCESSO,
        description: this.props.res.ORDEM_SERVICO_RETORNADA,
        icon: <MaterialIcon icon="check_circle" className="text-success" />
      });
    } catch (error) {
      this.setState({ sendingReturn: false });

      if (error && (error.status === 401 || error.status === 403)) {
        this.props.link('/login');
      } else {
        console.log(error);
        notification.open({
          message: this.props.res.ERRO,
          description: this.props.res.ERRO_MSG,
          icon: <MaterialIcon icon="error" className="text-danger" />
        });
      }
    }
  };

  cancelShareServiceOrder = () => {
    const ctx = this;
    const serviceOrderId = ctx.state.id;
    if (!serviceOrderId) return;

    ctx.setState({ sendingCancel: true });

    const url = Config.server + '/service_order/cancel_share/' + serviceOrderId;

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': localStorage.getItem('access-token-jwt')
      },
      body: JSON.stringify({})
    })
      .then(response =>
        response.json().then(data => ({ ok: response.ok, data }))
      )
      .then(resObj => {
        const ok = resObj.ok;
        const data = resObj.data || {};

        if (!ok) {
          throw new Error(
            ctx.props.res.COMPARTILHAMENTO_CANCELADO_ERRO
          );
        }

        notification.open({
          message: ctx.props.res.SUCESSO,
          description: ctx.props.res.COMPARTILHAMENTO_CANCELADO,
          icon: <MaterialIcon icon="check_circle" className="text-success" />

        });

        ctx.setState(prev => ({
          sendingCancel: false,
          share_status: data.share_status || 'criado',
          id_company_active:
            data.id_company_active != null
              ? data.id_company_active
              : prev.id_company_active,
          id_company_shared:
            typeof data.id_company_shared !== 'undefined'
              ? data.id_company_shared
              : null
        }));
      })
      .catch(err => {
        notification.open({
          message: ctx.props.res.ERRO,
          description: ctx.props.res.COMPARTILHAMENTO_CANCELADO_ERRO,
          icon: <MaterialIcon icon="error" className="text-danger" />
        });

        ctx.setState({ sendingCancel: false });
      });
  };

  loadAreas = (id, callback, stateKey) => {
    const apiUrl = Config.server + '/areas/' + id;
    let obj = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    fetch(apiUrl, obj)
      .then((res) => {
        if (res.status !== 200) {
          throw res;
        } else {
          return res.json();
        }
      })
      .then(
        (result) => {
          const areas = Array.isArray(result) ? result : [];
          const targetStateKey = stateKey || (Number(id) === 0 ? 'registeredAreas' : 'registeredAreasByClient');

          this.setState({ [targetStateKey]: areas }, () => {
            if (typeof callback === 'function') callback(areas);
          });
        },
        (error) => {
          if (error.status === 405) {
            notification.open({
              message: this.props.res.PERMISSAO,
              description: this.props.res.PERMISSAO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          } else if (error.status === 401 || error.status === 403) {
            this.props.link('/login');
          } else {
            console.log(error);
            notification.open({
              message: this.props.res.ERRO,
              description: this.props.res.ERRO_MSG,
              icon: <MaterialIcon icon="error" className="text-danger" />
            });
          }

          if (typeof callback === 'function') callback([]);
        }
      );
  };

  goToPrevSection = () => {
    this.setState((prevState) => ({
      tabValue: Math.max(0, Number(prevState.tabValue || 0) - 1)
    }));
  };

  goToNextSection = (totalSections) => {
    this.setState((prevState) => ({
      tabValue: Math.min(totalSections - 1, Number(prevState.tabValue || 0) + 1)
    }));
  };

  renderSectionNavigation = (totalSections) => {
    const currentStep = Number(this.state.tabValue || 0);

    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '2rem',
          paddingTop: '1rem',
          borderTop: '1px solid #e0e0e0',
        }}
      >
        <Button
          onClick={this.goToPrevSection}
          disabled={currentStep === 0}
          style={{
            minWidth: 0,
            textTransform: 'none',
            fontWeight: 500,
            borderRadius: 8,
            padding: '8px 14px',
          }}
        >
          <KeyboardArrowLeftIcon style={{ marginRight: 4 }} />
          {this.props.res.VOLTAR}

        </Button>

        <div style={{ fontSize: '0.95rem', color: '#666' }}>
          {currentStep + 1} / {totalSections}
        </div>

        <Button
          onClick={() => this.goToNextSection(totalSections)}
          disabled={currentStep === totalSections - 1}
          style={{
            minWidth: 0,
            textTransform: 'none',
            fontWeight: 500,
            borderRadius: 8,
            padding: '8px 14px',
          }}
        >
          {this.props.res.AVANCAR}
          <KeyboardArrowRightIcon style={{ marginLeft: 4 }} />
        </Button>
      </div>
    );
  };

  getCurrentJobPlaneDataForShare = () => {
    const currentJobState = this.state.jobs || null;
    const jobsData = Array.isArray(this.state.jobsData) ? this.state.jobsData : [];
    const firstJob = jobsData.length ? (jobsData[0] || null) : null;

    const planeId =
      currentJobState && currentJobState.planeId
        ? Number(currentJobState.planeId)
        : firstJob && firstJob.planeId
          ? Number(firstJob.planeId)
          : null;

    const planeName =
      currentJobState && currentJobState.plane
        ? String(currentJobState.plane)
        : firstJob && firstJob.plane
          ? String(firstJob.plane)
          : '';

    return {
      planeId: planeId,
      planeName: planeName
    };
  };

  loadRegisteredAreaProperties = (idClient, callback) => {
    if (!idClient) {
      this.setState({ registeredAreaProperties: [] }, () => {
        if (typeof callback === 'function') callback([]);
      });
      return;
    }

    const apiUrl = Config.server + '/properties/' + idClient;
    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then((result) => {
        const propertyList = Array.isArray(result) ? result : [];
        this.setState({ registeredAreaProperties: propertyList }, () => {
          if (typeof callback === 'function') callback(propertyList);
        });
      })
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        } else {
          console.log(error);
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }

        this.setState({ registeredAreaProperties: [] }, () => {
          if (typeof callback === 'function') callback([]);
        });
      });
  };

  loadRegisteredAreaFolders = (idClient, callback) => {
    if (!idClient) {
      this.setState({ registeredAreaFolders: [] }, () => {
        if (typeof callback === 'function') callback([]);
      });
      return;
    }

    const apiUrl = Config.server + '/folder_area/client/' + idClient;
    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then((result) => {
        const folderList = Array.isArray(result) ? result : [];
        this.setState({ registeredAreaFolders: folderList }, () => {
          if (typeof callback === 'function') callback(folderList);
        });
      })
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        } else {
          console.log(error);
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }

        this.setState({ registeredAreaFolders: [] }, () => {
          if (typeof callback === 'function') callback([]);
        });
      });
  };

  handleRegisteredAreaClientChange = (idClient, callback) => {
    if (!idClient) {
      this.setState({
        registeredAreaProperties: [],
        registeredAreaFolders: [],
        registeredAreasByClient: []
      }, () => {
        if (typeof callback === 'function') callback([]);
      });
      return;
    }

    this.loadRegisteredAreaProperties(idClient);
    this.loadRegisteredAreaFolders(idClient);
    this.loadAreas(idClient, callback, 'registeredAreasByClient');
  };

  readRunways = () => {
    const apiUrl = `${Config.server}/point/R`;
    const options = {
      method: 'GET',
      headers: {
        'Authorization': localStorage.getItem('access-token-jwt')
      }
    };

    fetch(apiUrl, options)
      .then((res) => {
        if (res.status !== 200) throw res;
        return res.json();
      })
      .then((result) => {
        this.setState({
          runways: Array.isArray(result) ? result : []
        });
      })
      .catch((error) => {
        if (error.status === 405) {
          notification.open({
            message: this.props.res.PERMISSAO,
            description: this.props.res.PERMISSAO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        } else if (error.status === 401 || error.status === 403) {
          this.props.link('/login');
        } else {
          notification.open({
            message: this.props.res.ERRO,
            description: this.props.res.ERRO_MSG,
            icon: <MaterialIcon icon="error" className="text-danger" />
          });
        }
      });
  };

  render() {
    const { link, res, profile, classes } = this.props;

    const statusOptions = [
      { value: 'Aberta', label: res.STATUS_ABERTA, tip: res.TIP_STATUS_ABERTA },
      { value: 'Aguardando Aprovação', label: res.STATUS_AGUARDANDO_APROVACAO, tip: res.TIP_STATUS_AGUARDANDO_APROVACAO },
      { value: 'Agendada', label: res.STATUS_AGENDADA, tip: res.TIP_STATUS_AGENDADA },
      { value: 'Em Execução', label: res.STATUS_EM_EXECUCAO, tip: res.TIP_STATUS_EM_EXECUCAO },
      { value: 'Em Espera', label: res.STATUS_EM_ESPERA, tip: res.TIP_STATUS_EM_ESPERA },
      { value: 'Concluída', label: res.STATUS_CONCLUIDA, tip: res.TIP_STATUS_CONCLUIDA },
      { value: 'Aguardando Validação', label: res.STATUS_AGUARDANDO_VALIDACAO, tip: res.TIP_STATUS_AGUARDANDO_VALIDACAO },
      { value: 'Faturada', label: res.STATUS_FATURADA, tip: res.TIP_STATUS_FATURADA },
      { value: 'Cancelada', label: res.STATUS_CANCELADA, tip: res.TIP_STATUS_CANCELADA },
    ];
    const selectedTip = (statusOptions.find(i => i.value === (this.state.status || '')) || {}).tip || '';

    const serviceStatusOptions = [
      { value: 'Aberto', label: res.SERV_STATUS_ABERTO },
      { value: 'Planejado', label: res.SERV_STATUS_PLANEJADO },
      { value: 'Executado', label: res.SERV_STATUS_EXECUTADO },
      { value: 'Concluído', label: res.SERV_STATUS_CONCLUIDO },
    ];

    const sections = [
      {
        key: 'client',
        content: (
          <ClientSection
            ctx={this}
            res={res}
            profile={profile}
            classes={classes}
            link={link}
          />
        )
      },
      {
        key: 'service',
        content: (
          <ServiceSection
            ctx={this}
            res={res}
            profile={profile}
            classes={classes}
            link={link}
            serviceStatusOptions={serviceStatusOptions}
          />
        )
      },
      {
        key: 'finance',
        content: (
          <FinanceSection
            ctx={this}
            res={res}
            profile={profile}
            classes={classes}
            link={link}
          />
        )
      },
      {
        key: 'signature',
        content: (
          <SignatureSection
            ctx={this}
            res={res}
            profile={profile}
            classes={classes}
            link={link}
          />
        )
      },
      {
        key: 'attachments',
        content: (
          <AttachmentsSection
            ctx={this}
            res={res}
            profile={profile}
            classes={classes}
            link={link}
          />
        )
      },
    ];

    const currentSectionIndex = Number(this.state.tabValue || 0);
    const currentSection = sections[currentSectionIndex] || sections[0];

    return (
      <div style={{ position: 'relative' }}>
        <div style={{ position: 'relative' }}>
          <Backdrop
            open={!!this.state.isSavingServiceOrder}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 2000,
              backgroundColor: 'rgba(255, 255, 255, 0.7)',
            }}
          >
            <CircularProgress size={64} style={{ color: '#9e9e9e' }} />
          </Backdrop>

          <div>
            <HeaderSection ctx={this} res={res} profile={profile} classes={classes} link={link} />
            <TitleSection
              ctx={this}
              res={res}
              profile={profile}
              classes={classes}
              link={link}
              statusOptions={statusOptions}
            />
            <div className="form-group" style={{ textAlign: 'left' }}>
              {currentSection.content}
              {this.renderSectionNavigation(sections.length)}

              <Dialog
                open={!!this.state.showPropertyForm}
                onClose={this.closePropertyModal}
                fullWidth
                maxWidth="md"
              >
                <EditProperty
                  key={this.state.propertyModalKey}
                  link={this.props.link}
                  res={this.props.res}
                  modal={true}
                  idClient={this.state.idClient}
                  idProperty={this.state.idProperty}
                  onSave={this.saveProperty}
                  onClose={this.closePropertyModal}
                />
              </Dialog>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Edit.propTypes = {
  classes: PropTypes.object.isRequired,
};

const TextFields1 = withStyles(styles)(Edit);

const Box = (props) => {
  const { link, res, profile } = props;
  const { id } = useParams();
  const location = useLocation();

  const query = location && location.state ? location.state : {};

  const jobOriginFromState =
    location && location.state && location.state.jobOrigin
      ? location.state.jobOrigin
      : null;

  let jobOrigin = jobOriginFromState;
  if (!jobOrigin) {
    try {
      const raw = sessionStorage.getItem('jobOrigin');
      jobOrigin = raw ? JSON.parse(raw) : null;
    } catch (_) { }
  }

  return (
    <div className="rowForm">
      <div className="divContent">
        <TextFields1 link={link} id={id} query={query} jobOrigin={jobOrigin} profile={profile} res={res} />
      </div>
    </div>
  );
};

export default Box;